"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * GALAXIE API
 * Galaxie API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: abderrahim.hafid@olaqin.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsRestApi = exports.TeamsRestApiFactory = exports.TeamsRestApiFp = exports.TeamsRestApiAxiosParamCreator = exports.TeamsPropertiesRestApi = exports.TeamsPropertiesRestApiFactory = exports.TeamsPropertiesRestApiFp = exports.TeamsPropertiesRestApiAxiosParamCreator = exports.TeamsContactsRestApi = exports.TeamsContactsRestApiFactory = exports.TeamsContactsRestApiFp = exports.TeamsContactsRestApiAxiosParamCreator = exports.SyntecIndexRestApi = exports.SyntecIndexRestApiFactory = exports.SyntecIndexRestApiFp = exports.SyntecIndexRestApiAxiosParamCreator = exports.SouscriptionsRestApi = exports.SouscriptionsRestApiFactory = exports.SouscriptionsRestApiFp = exports.SouscriptionsRestApiAxiosParamCreator = exports.SouchesRestApi = exports.SouchesRestApiFactory = exports.SouchesRestApiFp = exports.SouchesRestApiAxiosParamCreator = exports.ReportsRestApi = exports.ReportsRestApiFactory = exports.ReportsRestApiFp = exports.ReportsRestApiAxiosParamCreator = exports.PrestationsRestApi = exports.PrestationsRestApiFactory = exports.PrestationsRestApiFp = exports.PrestationsRestApiAxiosParamCreator = exports.PaymentTermRestApi = exports.PaymentTermRestApiFactory = exports.PaymentTermRestApiFp = exports.PaymentTermRestApiAxiosParamCreator = exports.OffresCommercialesRestApi = exports.OffresCommercialesRestApiFactory = exports.OffresCommercialesRestApiFp = exports.OffresCommercialesRestApiAxiosParamCreator = exports.ImportRestApi = exports.ImportRestApiFactory = exports.ImportRestApiFp = exports.ImportRestApiAxiosParamCreator = exports.DynamicsRestApi = exports.DynamicsRestApiFactory = exports.DynamicsRestApiFp = exports.DynamicsRestApiAxiosParamCreator = exports.DownloadRestApi = exports.DownloadRestApiFactory = exports.DownloadRestApiFp = exports.DownloadRestApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.ConditionRulesRestApi = exports.ConditionRulesRestApiFactory = exports.ConditionRulesRestApiFp = exports.ConditionRulesRestApiAxiosParamCreator = exports.ComptesCollectifsRestApi = exports.ComptesCollectifsRestApiFactory = exports.ComptesCollectifsRestApiFp = exports.ComptesCollectifsRestApiAxiosParamCreator = exports.CompanyDeliveryRestApi = exports.CompanyDeliveryRestApiFactory = exports.CompanyDeliveryRestApiFp = exports.CompanyDeliveryRestApiAxiosParamCreator = exports.CategoriesComptablesRestApi = exports.CategoriesComptablesRestApiFactory = exports.CategoriesComptablesRestApiFp = exports.CategoriesComptablesRestApiAxiosParamCreator = exports.ArticlesRestApi = exports.ArticlesRestApiFactory = exports.ArticlesRestApiFp = exports.ArticlesRestApiAxiosParamCreator = exports.ApplicationsMetiersPrestationsRestApi = exports.ApplicationsMetiersPrestationsRestApiFactory = exports.ApplicationsMetiersPrestationsRestApiFp = exports.ApplicationsMetiersPrestationsRestApiAxiosParamCreator = exports.AnomaliesRestApi = exports.AnomaliesRestApiFactory = exports.AnomaliesRestApiFp = exports.AnomaliesRestApiAxiosParamCreator = exports.UsageDataCalculationType = exports.TypePrestationOffre = exports.TierType = exports.TargetCible = exports.SyntecIndexFormTypeEnum = exports.SubscriptionStatusChangeResultMessagesTypeEnum = exports.SubscriptionStatus = exports.StellairClientsUsageReportEnvironmentEnum = exports.StellairClientsUsageReportStatusEnum = exports.StatutSouscription = exports.Sponsorship = exports.ServiceItemRepetition = exports.SavedReportType = exports.SalesTypology = exports.SageBase = exports.ReconductionRenouvellement = exports.QuantityLimitType = exports.Quality = exports.PricingRevisionIndexSettingsFormTypeEnum = exports.PricingRevisionIndexSettingsTypeEnum = exports.Periodicite = exports.EventStatus = exports.DateFacturation = exports.CustomerNature = exports.CountingConditionValue = exports.CountingConditionType = exports.CountingConditionCondition = exports.ClassificationGie = exports.Category = exports.BillingOrderType = exports.BillingOrderStatus = exports.AnomalyStatus = exports.Activity = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.Activity = {
    ActiviteMedicale: 'ACTIVITE_MEDICALE',
    Allergologue: 'ALLERGOLOGUE',
    Anesthesiste: 'ANESTHESISTE',
    Angiologue: 'ANGIOLOGUE',
    Architecte: 'ARCHITECTE',
    Association: 'ASSOCIATION',
    Autre: 'AUTRE',
    AutresProfLib: 'AUTRES_PROF_LIB',
    Biologiste: 'BIOLOGISTE',
    CabinetComptable: 'CABINET_COMPTABLE',
    Cancerologue: 'CANCEROLOGUE',
    Cardiologue: 'CARDIOLOGUE',
    CentreFormation: 'CENTRE_FORMATION',
    Chirurgie: 'CHIRURGIE',
    ChirurgieDenta: 'CHIRURGIE_DENTA',
    ChirurgieOrtho: 'CHIRURGIE_ORTHO',
    ChirurgieVasculaire: 'CHIRURGIE_VASCULAIRE',
    ChirurgieViscerale: 'CHIRURGIE_VISCERALE',
    Chirurgien: 'CHIRURGIEN',
    Cnda: 'CNDA',
    Consultant: 'CONSULTANT',
    Cpam: 'CPAM',
    Cytologie: 'CYTOLOGIE',
    Dentiste: 'DENTISTE',
    Dermatologue: 'DERMATOLOGUE',
    Dieteticienne: 'DIETETICIENNE',
    Divers: 'DIVERS',
    Echographiste: 'ECHOGRAPHISTE',
    Editeur: 'EDITEUR',
    Encadrement: 'ENCADREMENT',
    Endocrinologie: 'ENDOCRINOLOGIE',
    Endocrinologue: 'ENDOCRINOLOGUE',
    Ergotherapeute: 'ERGOTHERAPEUTE',
    ExpertComptable: 'EXPERT_COMPTABLE',
    Fournisseur: 'FOURNISSEUR',
    GastroEnterologue: 'GASTRO_ENTEROLOGUE',
    Generaliste: 'GENERALISTE',
    Geriatre: 'GERIATRE',
    Gerontologue: 'GERONTOLOGUE',
    Gynecologue: 'GYNECOLOGUE',
    Hypnotherapeute: 'HYPNOTHERAPEUTE',
    Infirmier: 'INFIRMIER',
    Infirmiere: 'INFIRMIERE',
    Informatique: 'INFORMATIQUE',
    IngenieurCommercial: 'INGENIEUR_COMMERCIAL',
    IngenieurConseil: 'INGENIEUR_CONSEIL',
    Kine: 'KINE',
    Laboratoire: 'LABORATOIRE',
    MaisonMedicale: 'MAISON_MEDICALE',
    MedecinDim: 'MEDECIN_DIM',
    MedecinInterne: 'MEDECIN_INTERNE',
    MedecinRadiotherapeute: 'MEDECIN_RADIOTHERAPEUTE',
    MedecineDuSommeil: 'MEDECINE_DU_SOMMEIL',
    MedecineDuTravail: 'MEDECINE_DU_TRAVAIL',
    MedecineInterne: 'MEDECINE_INTERNE',
    MedecineNucleaire: 'MEDECINE_NUCLEAIRE',
    MedecinePhysique: 'MEDECINE_PHYSIQUE',
    MedecineSportive: 'MEDECINE_SPORTIVE',
    MedecineVasculaire: 'MEDECINE_VASCULAIRE',
    NegociantAuto: 'NEGOCIANT_AUTO',
    Nephrologue: 'NEPHROLOGUE',
    Neurologue: 'NEUROLOGUE',
    Neuropsychiatre: 'NEUROPSYCHIATRE',
    Nutritionniste: 'NUTRITIONNISTE',
    Oncologue: 'ONCOLOGUE',
    Ophtalmologiste: 'OPHTALMOLOGISTE',
    OrgFinancement: 'ORG_FINANCEMENT',
    Orl: 'ORL',
    Orthesiste: 'ORTHESISTE',
    Orthodontiste: 'ORTHODONTISTE',
    Orthopediste: 'ORTHOPEDISTE',
    Orthophoniste: 'ORTHOPHONISTE',
    Orthoptiste: 'ORTHOPTISTE',
    Osteopathe: 'OSTEOPATHE',
    Pediatre: 'PEDIATRE',
    Phlebologue: 'PHLEBOLOGUE',
    Photographe: 'PHOTOGRAPHE',
    Pneumologue: 'PNEUMOLOGUE',
    Podologue: 'PODOLOGUE',
    Psychanalyste: 'PSYCHANALYSTE',
    Psychiatre: 'PSYCHIATRE',
    Psychologue: 'PSYCHOLOGUE',
    Radiologue: 'RADIOLOGUE',
    Revendeur: 'REVENDEUR',
    Rhumatologue: 'RHUMATOLOGUE',
    SageFemme: 'SAGE_FEMME',
    Samu: 'SAMU',
    Sexologue: 'SEXOLOGUE',
    Societe: 'SOCIETE',
    Stomatologie: 'STOMATOLOGIE',
    Stomatologue: 'STOMATOLOGUE',
    Urgentiste: 'URGENTISTE',
    Urologue: 'UROLOGUE',
    Veto: 'VETO'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AnomalyStatus = {
    OPEN: 'OPEN',
    FIXED: 'FIXED',
    CLOSED: 'CLOSED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BillingOrderStatus = {
    A_VENIR: 'A_VENIR',
    ANNULE: 'ANNULE',
    SUSPENDU: 'SUSPENDU',
    ANOMALIE: 'ANOMALIE',
    TRANSMIS: 'TRANSMIS',
    NON_TRANSMIS: 'NON_TRANSMIS',
    FACTURE: 'FACTURE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BillingOrderType = {
    RECURRENT: 'RECURRENT',
    PONCTUEL: 'PONCTUEL',
    USAGE: 'USAGE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Category = {
    Affid: 'AFFID',
    Arret: 'ARRET',
    ArretActivite: 'ARRET_ACTIVITE',
    ArretCdeAnnulee: 'ARRET_CDE_ANNULEE',
    ArretActiviteLiberale: 'ARRET_ACTIVITE_LIBERALE',
    ArretChgtLogiciel: 'ARRET_CHGT_LOGICIEL',
    ArretConges: 'ARRET_CONGES',
    ArretDeconventionne: 'ARRET_DECONVENTIONNE',
    ArretRetraite: 'ARRET_RETRAITE',
    ArretSansMotif: 'ARRET_SANS_MOTIF',
    Client: 'CLIENT',
    ClientOlaqin: 'CLIENT_OLAQIN',
    ClientPaj: 'CLIENT_PAJ',
    Cpam: 'CPAM',
    Editeur: 'EDITEUR',
    Revendeur: 'REVENDEUR',
    SuspensionAbo: 'SUSPENSION_ABO'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ClassificationGie = {
    AutreLieu: 'AUTRE_LIEU',
    AutreEtablissementDeSoins: 'AUTRE_ETABLISSEMENT_DE_SOINS',
    AuxiliaireMedical: 'AUXILIAIRE_MEDICAL',
    CentreDeSante: 'CENTRE_DE_SANTE',
    CliniqueEtPolyclinique: 'CLINIQUE_ET_POLYCLINIQUE',
    Dentiste: 'DENTISTE',
    Hopital: 'HOPITAL',
    LaPoste: 'LA_POSTE',
    LaboretoireDAnalysesMedicales: 'LABORETOIRE_D_ANALYSES_MEDICALES',
    Mairie: 'MAIRIE',
    Medecin: 'MEDECIN',
    OrganismeAssuranceMaladieComplementaire: 'ORGANISME_ASSURANCE_MALADIE_COMPLEMENTAIRE',
    OrganismeAssuranceMaladieObligatoire: 'ORGANISME_ASSURANCE_MALADIE_OBLIGATOIRE',
    Pharmacie: 'PHARMACIE',
    ProfessionnelDeLaLpp: 'PROFESSIONNEL_DE_LA_LPP',
    Transporteur: 'TRANSPORTEUR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CountingConditionCondition = {
    IS: 'Is',
    IS_NOT: 'Is not',
    CONTAINS: 'Contains',
    DOES_NOT_CONTAIN: 'Does not contain',
    IS_BEFORE: 'Is before'
};
/**
 * Possible condition (is, is not, contains, does not contain)
 * @export
 * @enum {string}
 */
exports.CountingConditionType = {
    DATE: 'Date',
    ROLE: 'Role',
    STATE: 'State',
    TYPE: 'Type'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CountingConditionValue = {
    ACTIVATED: 'Activated',
    CREATED: 'Created',
    USER: 'User',
    SUPERVISOR: 'Supervisor',
    ONE_MONTH: '1 month',
    TWO_MONTH: '2 month',
    THREE_MONTH: '3 month',
    REGULAR: 'Client',
    TEST: 'Test',
    TRIAL: 'Essai',
    OLAQIN_STAFF: 'Utilisateur interne Olaqin',
    UNKNOWN: 'Inconnu'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CustomerNature = {
    Direct: 'DIRECT',
    Indirect: 'INDIRECT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DateFacturation = {
    /**
    * Au début de la période de facturation
    */
    BeginningOfThePeriod: 'BEGINNING_OF_THE_PERIOD',
    /**
    * 1 mois avant le début de la période de facturation
    */
    OneMonthBeforeBeginningOfBillingPeriod: 'ONE_MONTH_BEFORE_BEGINNING_OF_BILLING_PERIOD',
    /**
    * Echoir, le paiement doit se faire en avance
    */
    Echoir: 'ECHOIR',
    /**
    * Echue, le paiement est réalisé après ou ultérieurement
    */
    Echue: 'ECHUE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EventStatus = {
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
    INFO: 'INFO'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Periodicite = {
    /**
    * Mensuelle
    */
    Mensuelle: 'MENSUELLE',
    /**
    * Trimestrielle
    */
    Trimestrielle: 'TRIMESTRIELLE',
    /**
    * Semestrielle
    */
    Semestrielle: 'SEMESTRIELLE',
    /**
    * Annuelle
    */
    Annuelle: 'ANNUELLE'
};
exports.PricingRevisionIndexSettingsTypeEnum = {
    /**
    * Current Monthly Syntec Index at Activation
    */
    Monthly: 'MONTHLY',
    /**
    * Current Annual Syntec Index at Activation
    */
    Annual: 'ANNUAL',
    /**
    * Specific Index
    */
    Custom: 'CUSTOM',
    /**
    * No Tariff Revision
    */
    NoIndex: 'NO_INDEX'
};
exports.PricingRevisionIndexSettingsFormTypeEnum = {
    /**
    * Current Monthly Syntec Index at Activation
    */
    Monthly: 'MONTHLY',
    /**
    * Current Annual Syntec Index at Activation
    */
    Annual: 'ANNUAL',
    /**
    * Specific Index
    */
    Custom: 'CUSTOM',
    /**
    * No Tariff Revision
    */
    NoIndex: 'NO_INDEX'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Quality = {
    Association: 'ASSOCIATION',
    Cabinet: 'CABINET',
    Centre: 'CENTRE',
    Clinique: 'CLINIQUE',
    Docteur: 'DOCTEUR',
    Docteurs: 'DOCTEURS',
    Madame: 'MADAME',
    Mademoiselle: 'MADEMOISELLE',
    Monsieur: 'MONSIEUR',
    Societe: 'SOCIETE',
    Tresorier: 'TRESORIER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.QuantityLimitType = {
    Until: 'UNTIL',
    From: 'FROM'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReconductionRenouvellement = {
    /**
    * Aucune
    */
    Aucune: 'AUCUNE',
    /**
    * tacite
    */
    Tacite: 'TACITE',
    /**
    * À confirmer
    */
    AConfirmer: 'A_CONFIRMER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SageBase = {
    /**
    * Service
    */
    Service: 'SERVICE',
    /**
    * Hardware
    */
    Hardware: 'HARDWARE',
    /**
    * Affid
    */
    Affid: 'AFFID'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SalesTypology = {
    AncientClient: 'ANCIENT_CLIENT',
    Association: 'ASSOCIATION',
    Assurance: 'ASSURANCE',
    Auchan: 'AUCHAN',
    Audition: 'AUDITION',
    Autre: 'AUTRE',
    BioAccess: 'BIO_ACCESS',
    Biogroup: 'BIOGROUP',
    BoutiqueDeLogiciels: 'BOUTIQUE_DE_LOGICIELS',
    Caih: 'CAIH',
    Cerballiance: 'CERBALLIANCE',
    CentreHospitalier: 'CENTRE_HOSPITALIER',
    CentreHospitalierPrive: 'CENTRE_HOSPITALIER_PRIVE',
    CentreDeSanteCabinetMedical: 'CENTRE_DE_SANTE_CABINET_MEDICAL',
    ClientCaihByStellair: 'CLIENT_CAIH_BY_STELLAIR',
    StellairAffidClient: 'STELLAIR_AFFID_CLIENT',
    AffidClient: 'AFFID_CLIENT',
    ClientStellair: 'CLIENT_STELLAIR',
    CliniqueEtPolyclinique: 'CLINIQUE_ET_POLYCLINIQUE',
    CliniqueEtPolycliniquePrive: 'CLINIQUE_ET_POLYCLINIQUE_PRIVE',
    CureThermale: 'CURE_THERMALE',
    Ehpad: 'EHPAD',
    EtablissementPublic: 'ETABLISSEMENT_PUBLIC',
    GrossisteRevendeur: 'GROSSISTE_REVENDEUR',
    HarmonieMutuelle: 'HARMONIE_MUTUELLE',
    ImagerieMedicale: 'IMAGERIE_MEDICALE',
    ImagerieMedicalePrive: 'IMAGERIE_MEDICALE_PRIVE',
    Infirmier: 'INFIRMIER',
    Laboratoire: 'LABORATOIRE',
    MagasinDeMaterielMedical: 'MAGASIN_DE_MATERIEL_MEDICAL',
    Mairie: 'MAIRIE',
    Medecin: 'MEDECIN',
    MutuelleEtPrevoyance: 'MUTUELLE_ET_PREVOYANCE',
    Orpea: 'ORPEA',
    Optique: 'OPTIQUE',
    PartenaireStellair: 'PARTENAIRE_STELLAIR',
    Pharmacie: 'PHARMACIE',
    ThelemAssurance: 'THELEM_ASSURANCE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SavedReportType = {
    Subscription: 'SUBSCRIPTION',
    Client: 'CLIENT',
    BillingOrder: 'BILLING_ORDER',
    ClientAll: 'CLIENT_ALL',
    Offer: 'OFFER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceItemRepetition = {
    OneTime: 'ONE_TIME',
    Recurring: 'RECURRING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Sponsorship = {
    Parrain1: 'PARRAIN1',
    Parrain2: 'PARRAIN2',
    Parrain3: 'PARRAIN3',
    Parrain4: 'PARRAIN4',
    Parrain5: 'PARRAIN5',
    Parrain6: 'PARRAIN6',
    Parrain7: 'PARRAIN7',
    Parrain8: 'PARRAIN8',
    Parrain9: 'PARRAIN9',
    Parrain10: 'PARRAIN10',
    Parrain11: 'PARRAIN11',
    Parrain12: 'PARRAIN12',
    Filleul: 'FILLEUL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.StatutSouscription = {
    INCOMPLETE: 'Incomplète',
    ACTIVE: 'Active',
    ANOMALIE: 'Anomalie',
    CANCEL: 'Interrompue',
    CLOSED: 'Résiliée'
};
exports.StellairClientsUsageReportStatusEnum = {
    /**
    * Anomalie
    */
    Anomalie: 'ANOMALIE',
    /**
    * Clôturé
    */
    Transmis: 'TRANSMIS',
    /**
    * Opération en cours
    */
    InProgress: 'IN_PROGRESS'
};
exports.StellairClientsUsageReportEnvironmentEnum = {
    BETA: 'Beta',
    ORIGINAL: 'Prod'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SubscriptionStatus = {
    ACTIVE: 'ACTIVE',
    TERMINATED: 'TERMINATED',
    CLOSED: 'CLOSED'
};
exports.SubscriptionStatusChangeResultMessagesTypeEnum = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info'
};
exports.SyntecIndexFormTypeEnum = {
    MONTH: 'MONTH',
    YEAR: 'YEAR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TargetCible = {
    AffidNxt: 'AFFID_NXT',
    Cd2019AffidAsso: 'CD2019_AFFID_ASSO',
    Cd2019AffidIndiv: 'CD2019_AFFID_INDIV',
    Cd2019Ajout: 'CD2019_AJOUT',
    Cd2019Dastot: 'CD2019_DASTOT',
    Cd2019Helpinfo: 'CD2019_HELPINFO',
    Cd2019Phc: 'CD2019_PHC',
    Cd2019Rev: 'CD2019_REV',
    Cd2020AffidAsso: 'CD2020_AFFID_ASSO',
    Cd2020AffidHelpinfo: 'CD2020_AFFID_HELPINFO',
    Cd2020AffidIndiv: 'CD2020_AFFID_INDIV',
    Cd2020AffidRev: 'CD2020_AFFID_REV',
    MadNeo: 'MAD_NEO',
    MadPrium: 'MAD_PRIUM',
    MadTpeIwlSeul: 'MAD_TPE_IWL_SEUL',
    MmgStlIllSupc: 'MMG_STL_ILL_SUPC',
    MmgStlIllSupcPrium: 'MMG_STL_ILL_SUPC_PRIUM',
    MmgStlIllSupo: 'MMG_STL_ILL_SUPO',
    MmgStlIllSupoPrium: 'MMG_STL_ILL_SUPO_PRIUM',
    Nxt2019: 'NXT2019',
    Nxt2021: 'NXT2021',
    Nxt2021Rev: 'NXT2021REV',
    Nxt2022: 'NXT2022',
    Nxt2022Prium: 'NXT2022_PRIUM',
    Nxt2022Rev: 'NXT2022REV',
    Pyxvital: 'PYXVITAL',
    StlIll: 'STL_ILL',
    StlIllNeo: 'STL_ILL_NEO',
    StlIllNeoPrium: 'STL_ILL_NEO_PRIUM',
    StlIllPrium: 'STL_ILL_PRIUM',
    StlIllTpe: 'STL_ILL_TPE',
    StlOlaqin: 'STL_OLAQIN',
    StlUsag: 'STL_USAG',
    StlUsagNeo: 'STL_USAG_NEO',
    Cd2020Rev: 'CD2020_REV',
    Cd2020Helpinfo: 'CD2020_HELPINFO',
    Cd2017: 'CD2017',
    Cd2017Rev: 'CD2017_REV',
    Cd2014AffidIndiv: 'CD2014_AFFID_INDIV',
    Nxt2023Mad: 'NXT2023_MAD',
    Cd2017AffidIndiv: 'CD2017_AFFID_INDIV',
    Cd2018AffidAsso: 'CD2018_AFFID_ASSO',
    Cd2018AffidIndiv: 'CD2018_AFFID_INDIV',
    Cd2016: 'CD2016',
    Cd2017AffidAsso: 'CD2017_AFFID_ASSO',
    StlUsagPrium: 'STL_USAG_PRIUM',
    Nxt2023Rev: 'NXT2023REV',
    Nxt2023: 'NXT2023'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TierType = {
    GraduatedPricing: 'GRADUATED_PRICING',
    VolumePricing: 'VOLUME_PRICING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TypePrestationOffre = {
    /**
    * Primaire
    */
    Primaire: 'PRIMAIRE',
    /**
    * Obligatoire
    */
    Obligatoire: 'OBLIGATOIRE',
    /**
    * Optionnelle
    */
    Optionnelle: 'OPTIONNELLE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UsageDataCalculationType = {
    Fse: 'FSE',
    Utilisateurs: 'UTILISATEURS'
};
/**
 * AnomaliesRestApi - axios parameter creator
 * @export
 */
exports.AnomaliesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Resolve anomalie
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalie: (anomalieId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'anomalieId' is not null or undefined
            common_1.assertParamExists('resolveAnomalie', 'anomalieId', anomalieId);
            const localVarPath = `/anomalies/{anomalieId}/resolve`
                .replace(`{${"anomalieId"}}`, encodeURIComponent(String(anomalieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reload stellair data report
         * @param {string} stellairReportId Stellair Report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveStellairAnomalie: (stellairReportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'stellairReportId' is not null or undefined
            common_1.assertParamExists('resolveStellairAnomalie', 'stellairReportId', stellairReportId);
            const localVarPath = `/anomalies/stellair/{stellairReportId}/reload`
                .replace(`{${"stellairReportId"}}`, encodeURIComponent(String(stellairReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AnomaliesRestApi - functional programming interface
 * @export
 */
exports.AnomaliesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AnomaliesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Resolve anomalie
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalie(anomalieId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveAnomalie(anomalieId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reload stellair data report
         * @param {string} stellairReportId Stellair Report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveStellairAnomalie(stellairReportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveStellairAnomalie(stellairReportId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AnomaliesRestApi - factory interface
 * @export
 */
exports.AnomaliesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AnomaliesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Resolve anomalie
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalie(anomalieId, options) {
            return localVarFp.resolveAnomalie(anomalieId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reload stellair data report
         * @param {string} stellairReportId Stellair Report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveStellairAnomalie(stellairReportId, options) {
            return localVarFp.resolveStellairAnomalie(stellairReportId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnomaliesRestApi - object-oriented interface
 * @export
 * @class AnomaliesRestApi
 * @extends {BaseAPI}
 */
class AnomaliesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Resolve anomalie
     * @param {string} anomalieId Anomalie id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnomaliesRestApi
     */
    resolveAnomalie(anomalieId, options) {
        return exports.AnomaliesRestApiFp(this.configuration).resolveAnomalie(anomalieId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reload stellair data report
     * @param {string} stellairReportId Stellair Report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnomaliesRestApi
     */
    resolveStellairAnomalie(stellairReportId, options) {
        return exports.AnomaliesRestApiFp(this.configuration).resolveStellairAnomalie(stellairReportId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AnomaliesRestApi = AnomaliesRestApi;
/**
 * ApplicationsMetiersPrestationsRestApi - axios parameter creator
 * @export
 */
exports.ApplicationsMetiersPrestationsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Usage data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerApplicationsMetiersPrestationUsageDataTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/applications-metiers-prestations/usage-data-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ApplicationsMetiersPrestationsRestApi - functional programming interface
 * @export
 */
exports.ApplicationsMetiersPrestationsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ApplicationsMetiersPrestationsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get Usage data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerApplicationsMetiersPrestationUsageDataTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerApplicationsMetiersPrestationUsageDataTypes(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ApplicationsMetiersPrestationsRestApi - factory interface
 * @export
 */
exports.ApplicationsMetiersPrestationsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ApplicationsMetiersPrestationsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Get Usage data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerApplicationsMetiersPrestationUsageDataTypes(options) {
            return localVarFp.listerApplicationsMetiersPrestationUsageDataTypes(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApplicationsMetiersPrestationsRestApi - object-oriented interface
 * @export
 * @class ApplicationsMetiersPrestationsRestApi
 * @extends {BaseAPI}
 */
class ApplicationsMetiersPrestationsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get Usage data type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsMetiersPrestationsRestApi
     */
    listerApplicationsMetiersPrestationUsageDataTypes(options) {
        return exports.ApplicationsMetiersPrestationsRestApiFp(this.configuration).listerApplicationsMetiersPrestationUsageDataTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ApplicationsMetiersPrestationsRestApi = ApplicationsMetiersPrestationsRestApi;
/**
 * ArticlesRestApi - axios parameter creator
 * @export
 */
exports.ArticlesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Afficher la liste des articles
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerArticles: (fromSage, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromSage !== undefined) {
                localVarQueryParameter['fromSage'] = fromSage;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ArticlesRestApi - functional programming interface
 * @export
 */
exports.ArticlesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ArticlesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des articles
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerArticles(fromSage, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerArticles(fromSage, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ArticlesRestApi - factory interface
 * @export
 */
exports.ArticlesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ArticlesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des articles
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerArticles(fromSage, sageBase, options) {
            return localVarFp.listerArticles(fromSage, sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ArticlesRestApi - object-oriented interface
 * @export
 * @class ArticlesRestApi
 * @extends {BaseAPI}
 */
class ArticlesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Afficher la liste des articles
     * @param {boolean} [fromSage]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesRestApi
     */
    listerArticles(fromSage, sageBase, options) {
        return exports.ArticlesRestApiFp(this.configuration).listerArticles(fromSage, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ArticlesRestApi = ArticlesRestApi;
/**
 * CategoriesComptablesRestApi - axios parameter creator
 * @export
 */
exports.CategoriesComptablesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Afficher la liste des catégories comptables
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerCategorieComptables: (fromSage, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/categories-comptables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromSage !== undefined) {
                localVarQueryParameter['fromSage'] = fromSage;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CategoriesComptablesRestApi - functional programming interface
 * @export
 */
exports.CategoriesComptablesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CategoriesComptablesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des catégories comptables
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerCategorieComptables(fromSage, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerCategorieComptables(fromSage, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CategoriesComptablesRestApi - factory interface
 * @export
 */
exports.CategoriesComptablesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CategoriesComptablesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des catégories comptables
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerCategorieComptables(fromSage, sageBase, options) {
            return localVarFp.listerCategorieComptables(fromSage, sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoriesComptablesRestApi - object-oriented interface
 * @export
 * @class CategoriesComptablesRestApi
 * @extends {BaseAPI}
 */
class CategoriesComptablesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Afficher la liste des catégories comptables
     * @param {boolean} [fromSage]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesComptablesRestApi
     */
    listerCategorieComptables(fromSage, sageBase, options) {
        return exports.CategoriesComptablesRestApiFp(this.configuration).listerCategorieComptables(fromSage, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CategoriesComptablesRestApi = CategoriesComptablesRestApi;
/**
 * CompanyDeliveryRestApi - axios parameter creator
 * @export
 */
exports.CompanyDeliveryRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDelivery: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/company/delivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDeliveryRequirement: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sageBase' is not null or undefined
            common_1.assertParamExists('companyDeliveryRequirement', 'sageBase', sageBase);
            const localVarPath = `/company/delivery-requirement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyDeliveryRestApi - functional programming interface
 * @export
 */
exports.CompanyDeliveryRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CompanyDeliveryRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDelivery(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.companyDelivery(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDeliveryRequirement(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.companyDeliveryRequirement(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyDeliveryRestApi - factory interface
 * @export
 */
exports.CompanyDeliveryRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CompanyDeliveryRestApiFp(configuration);
    return {
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDelivery(sageBase, options) {
            return localVarFp.companyDelivery(sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get expedition mode
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyDeliveryRequirement(sageBase, options) {
            return localVarFp.companyDeliveryRequirement(sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyDeliveryRestApi - object-oriented interface
 * @export
 * @class CompanyDeliveryRestApi
 * @extends {BaseAPI}
 */
class CompanyDeliveryRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get expedition mode
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDeliveryRestApi
     */
    companyDelivery(sageBase, options) {
        return exports.CompanyDeliveryRestApiFp(this.configuration).companyDelivery(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get expedition mode
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDeliveryRestApi
     */
    companyDeliveryRequirement(sageBase, options) {
        return exports.CompanyDeliveryRestApiFp(this.configuration).companyDeliveryRequirement(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompanyDeliveryRestApi = CompanyDeliveryRestApi;
/**
 * ComptesCollectifsRestApi - axios parameter creator
 * @export
 */
exports.ComptesCollectifsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Afficher la liste des comptes collectifs
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerComptesCollectifs: (fromSage, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/comptes-collectifs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromSage !== undefined) {
                localVarQueryParameter['fromSage'] = fromSage;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ComptesCollectifsRestApi - functional programming interface
 * @export
 */
exports.ComptesCollectifsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ComptesCollectifsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des comptes collectifs
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerComptesCollectifs(fromSage, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerComptesCollectifs(fromSage, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ComptesCollectifsRestApi - factory interface
 * @export
 */
exports.ComptesCollectifsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ComptesCollectifsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des comptes collectifs
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerComptesCollectifs(fromSage, sageBase, options) {
            return localVarFp.listerComptesCollectifs(fromSage, sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComptesCollectifsRestApi - object-oriented interface
 * @export
 * @class ComptesCollectifsRestApi
 * @extends {BaseAPI}
 */
class ComptesCollectifsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Afficher la liste des comptes collectifs
     * @param {boolean} [fromSage]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComptesCollectifsRestApi
     */
    listerComptesCollectifs(fromSage, sageBase, options) {
        return exports.ComptesCollectifsRestApiFp(this.configuration).listerComptesCollectifs(fromSage, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ComptesCollectifsRestApi = ComptesCollectifsRestApi;
/**
 * ConditionRulesRestApi - axios parameter creator
 * @export
 */
exports.ConditionRulesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Available condition rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionRules: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/condition/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConditionRulesRestApi - functional programming interface
 * @export
 */
exports.ConditionRulesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ConditionRulesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Available condition rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionRules(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conditionRules(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConditionRulesRestApi - factory interface
 * @export
 */
exports.ConditionRulesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ConditionRulesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Available condition rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionRules(options) {
            return localVarFp.conditionRules(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConditionRulesRestApi - object-oriented interface
 * @export
 * @class ConditionRulesRestApi
 * @extends {BaseAPI}
 */
class ConditionRulesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Available condition rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConditionRulesRestApi
     */
    conditionRules(options) {
        return exports.ConditionRulesRestApiFp(this.configuration).conditionRules(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConditionRulesRestApi = ConditionRulesRestApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categorieComptableOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/categories-comptables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compteCollectifOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/comptes-collectifs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionOptions: (souscriptionId, contractFileLinkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionOptions', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionOptions', 'contractFileLinkId', contractFileLinkId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/download`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKeyOptions: (souscriptionId, contractFileLinkId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKeyOptions', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKeyOptions', 'contractFileLinkId', contractFileLinkId);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKeyOptions', 'key', key);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/downloadWithKey`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscriptionOptions: (souscriptionId, contractFileLinkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('getDownloadKeyForDownloadingContractFileForSubscriptionOptions', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('getDownloadKeyForDownloadingContractFileForSubscriptionOptions', 'contractFileLinkId', contractFileLinkId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/getDownloadKey`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lierOffreCommercialeCodeSoucheOptions: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('lierOffreCommercialeCodeSoucheOptions', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/complete`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAllOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/offres-commerciales/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/offres-commerciales/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestationsOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/prestations/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptionsOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/souscriptions/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOperationsOptions: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('offresCommercialesOperationsOptions', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/offres-commerciales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prestationsOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommercialeOptions: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('publishOffreCommercialeOptions', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/publish`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souchesOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/souches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souscriptionsOptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/souscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscriptionOptions: (souscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('uploadContractFileForSubscriptionOptions', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/uploadContract`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'OPTIONS' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categorieComptableOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.categorieComptableOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compteCollectifOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.compteCollectifOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAllOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerOffresCommercialesAllOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerOffresCommercialesOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestationsOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerPrestationsOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptionsOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerSouscriptionsOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOperationsOptions(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offresCommercialesOperationsOptions(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offresCommercialesOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prestationsOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prestationsOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommercialeOptions(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishOffreCommercialeOptions(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souchesOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.souchesOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souscriptionsOptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.souscriptionsOptions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscriptionOptions(souscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadContractFileForSubscriptionOptions(souscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOptions(options) {
            return localVarFp.articlesOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categorieComptableOptions(options) {
            return localVarFp.categorieComptableOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compteCollectifOptions(options) {
            return localVarFp.compteCollectifOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
            return localVarFp.downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options) {
            return localVarFp.downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
            return localVarFp.getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options) {
            return localVarFp.lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAllOptions(options) {
            return localVarFp.listerOffresCommercialesAllOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesOptions(options) {
            return localVarFp.listerOffresCommercialesOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestationsOptions(options) {
            return localVarFp.listerPrestationsOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptionsOptions(options) {
            return localVarFp.listerSouscriptionsOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOperationsOptions(offreCommercialeId, options) {
            return localVarFp.offresCommercialesOperationsOptions(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offresCommercialesOptions(options) {
            return localVarFp.offresCommercialesOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prestationsOptions(options) {
            return localVarFp.prestationsOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommercialeOptions(offreCommercialeId, options) {
            return localVarFp.publishOffreCommercialeOptions(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souchesOptions(options) {
            return localVarFp.souchesOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        souscriptionsOptions(options) {
            return localVarFp.souscriptionsOptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscriptionOptions(souscriptionId, options) {
            return localVarFp.uploadContractFileForSubscriptionOptions(souscriptionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    articlesOptions(options) {
        return exports.DefaultApiFp(this.configuration).articlesOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    categorieComptableOptions(options) {
        return exports.DefaultApiFp(this.configuration).categorieComptableOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    compteCollectifOptions(options) {
        return exports.DefaultApiFp(this.configuration).compteCollectifOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
        return exports.DefaultApiFp(this.configuration).downloadContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract
     * @param {string} key Download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options) {
        return exports.DefaultApiFp(this.configuration).downloadContractFileForSubscriptionWithDownloadKeyOptions(souscriptionId, contractFileLinkId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options) {
        return exports.DefaultApiFp(this.configuration).getDownloadKeyForDownloadingContractFileForSubscriptionOptions(souscriptionId, contractFileLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options) {
        return exports.DefaultApiFp(this.configuration).lierOffreCommercialeCodeSoucheOptions(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listerOffresCommercialesAllOptions(options) {
        return exports.DefaultApiFp(this.configuration).listerOffresCommercialesAllOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listerOffresCommercialesOptions(options) {
        return exports.DefaultApiFp(this.configuration).listerOffresCommercialesOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listerPrestationsOptions(options) {
        return exports.DefaultApiFp(this.configuration).listerPrestationsOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listerSouscriptionsOptions(options) {
        return exports.DefaultApiFp(this.configuration).listerSouscriptionsOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    offresCommercialesOperationsOptions(offreCommercialeId, options) {
        return exports.DefaultApiFp(this.configuration).offresCommercialesOperationsOptions(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    offresCommercialesOptions(options) {
        return exports.DefaultApiFp(this.configuration).offresCommercialesOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    prestationsOptions(options) {
        return exports.DefaultApiFp(this.configuration).prestationsOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    publishOffreCommercialeOptions(offreCommercialeId, options) {
        return exports.DefaultApiFp(this.configuration).publishOffreCommercialeOptions(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    souchesOptions(options) {
        return exports.DefaultApiFp(this.configuration).souchesOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    souscriptionsOptions(options) {
        return exports.DefaultApiFp(this.configuration).souscriptionsOptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    uploadContractFileForSubscriptionOptions(souscriptionId, options) {
        return exports.DefaultApiFp(this.configuration).uploadContractFileForSubscriptionOptions(souscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * DownloadRestApi - axios parameter creator
 * @export
 */
exports.DownloadRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKey: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/download/downloadKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DownloadRestApi - functional programming interface
 * @export
 */
exports.DownloadRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DownloadRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDownloadKey(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DownloadRestApi - factory interface
 * @export
 */
exports.DownloadRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DownloadRestApiFp(configuration);
    return {
        /**
         *
         * @summary Get download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKey(options) {
            return localVarFp.getDownloadKey(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DownloadRestApi - object-oriented interface
 * @export
 * @class DownloadRestApi
 * @extends {BaseAPI}
 */
class DownloadRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadRestApi
     */
    getDownloadKey(options) {
        return exports.DownloadRestApiFp(this.configuration).getDownloadKey(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DownloadRestApi = DownloadRestApi;
/**
 * DynamicsRestApi - axios parameter creator
 * @export
 */
exports.DynamicsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create Client in Dynamics
         * @param {string} clientId Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientInDynamics: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('createClientInDynamics', 'clientId', clientId);
            const localVarPath = `/dynamics/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Client in Dynamics
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInDynamics: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('updateClientInDynamics', 'clientId', clientId);
            const localVarPath = `/dynamics/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DynamicsRestApi - functional programming interface
 * @export
 */
exports.DynamicsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DynamicsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create Client in Dynamics
         * @param {string} clientId Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientInDynamics(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createClientInDynamics(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Client in Dynamics
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInDynamics(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateClientInDynamics(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DynamicsRestApi - factory interface
 * @export
 */
exports.DynamicsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DynamicsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Create Client in Dynamics
         * @param {string} clientId Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientInDynamics(clientId, options) {
            return localVarFp.createClientInDynamics(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Client in Dynamics
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientInDynamics(clientId, options) {
            return localVarFp.updateClientInDynamics(clientId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DynamicsRestApi - object-oriented interface
 * @export
 * @class DynamicsRestApi
 * @extends {BaseAPI}
 */
class DynamicsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create Client in Dynamics
     * @param {string} clientId Numero Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DynamicsRestApi
     */
    createClientInDynamics(clientId, options) {
        return exports.DynamicsRestApiFp(this.configuration).createClientInDynamics(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Client in Dynamics
     * @param {string} clientId Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DynamicsRestApi
     */
    updateClientInDynamics(clientId, options) {
        return exports.DynamicsRestApiFp(this.configuration).updateClientInDynamics(clientId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DynamicsRestApi = DynamicsRestApi;
/**
 * ImportRestApi - axios parameter creator
 * @export
 */
exports.ImportRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a csv template file for importing clients by POST /import/clients/file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportClientTemplateFile: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/clients/download/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Import Clients data from Sage
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsDataFromSage: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sageBase' is not null or undefined
            common_1.assertParamExists('importClientsDataFromSage', 'sageBase', sageBase);
            const localVarPath = `/import/clients/sage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Integrate Customer Data between Niqola and Microsoft Dynamics via CSV Import
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromDynamics: (name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/clients/dynamics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Importing clients from a CSV file
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromFile: (name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/clients/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Import Offer data
         * @param {OfferDataImport} offerDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOfferData: (offerDataImport, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerDataImport' is not null or undefined
            common_1.assertParamExists('importOfferData', 'offerDataImport', offerDataImport);
            const localVarPath = `/import/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(offerDataImport, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Import ongoing subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOngoingSubscriptions: (name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Import Prestations data
         * @param {PrestationsDataImport} prestationsDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPrestationsData: (prestationsDataImport, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prestationsDataImport' is not null or undefined
            common_1.assertParamExists('importPrestationsData', 'prestationsDataImport', prestationsDataImport);
            const localVarPath = `/import/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(prestationsDataImport, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ImportRestApi - functional programming interface
 * @export
 */
exports.ImportRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ImportRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a csv template file for importing clients by POST /import/clients/file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportClientTemplateFile(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadImportClientTemplateFile(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Import Clients data from Sage
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsDataFromSage(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importClientsDataFromSage(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Integrate Customer Data between Niqola and Microsoft Dynamics via CSV Import
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromDynamics(name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importClientsFromDynamics(name, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Importing clients from a CSV file
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromFile(name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importClientsFromFile(name, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Import Offer data
         * @param {OfferDataImport} offerDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOfferData(offerDataImport, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importOfferData(offerDataImport, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Import ongoing subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOngoingSubscriptions(name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importOngoingSubscriptions(name, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Import Prestations data
         * @param {PrestationsDataImport} prestationsDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPrestationsData(prestationsDataImport, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importPrestationsData(prestationsDataImport, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ImportRestApi - factory interface
 * @export
 */
exports.ImportRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ImportRestApiFp(configuration);
    return {
        /**
         *
         * @summary Get a csv template file for importing clients by POST /import/clients/file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportClientTemplateFile(options) {
            return localVarFp.downloadImportClientTemplateFile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import Clients data from Sage
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsDataFromSage(sageBase, options) {
            return localVarFp.importClientsDataFromSage(sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Integrate Customer Data between Niqola and Microsoft Dynamics via CSV Import
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromDynamics(name, file, options) {
            return localVarFp.importClientsFromDynamics(name, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Importing clients from a CSV file
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importClientsFromFile(name, file, options) {
            return localVarFp.importClientsFromFile(name, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import Offer data
         * @param {OfferDataImport} offerDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOfferData(offerDataImport, options) {
            return localVarFp.importOfferData(offerDataImport, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import ongoing subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOngoingSubscriptions(name, file, options) {
            return localVarFp.importOngoingSubscriptions(name, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import Prestations data
         * @param {PrestationsDataImport} prestationsDataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPrestationsData(prestationsDataImport, options) {
            return localVarFp.importPrestationsData(prestationsDataImport, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ImportRestApi - object-oriented interface
 * @export
 * @class ImportRestApi
 * @extends {BaseAPI}
 */
class ImportRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get a csv template file for importing clients by POST /import/clients/file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    downloadImportClientTemplateFile(options) {
        return exports.ImportRestApiFp(this.configuration).downloadImportClientTemplateFile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Import Clients data from Sage
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importClientsDataFromSage(sageBase, options) {
        return exports.ImportRestApiFp(this.configuration).importClientsDataFromSage(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Integrate Customer Data between Niqola and Microsoft Dynamics via CSV Import
     * @param {string} [name]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importClientsFromDynamics(name, file, options) {
        return exports.ImportRestApiFp(this.configuration).importClientsFromDynamics(name, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Importing clients from a CSV file
     * @param {string} [name]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importClientsFromFile(name, file, options) {
        return exports.ImportRestApiFp(this.configuration).importClientsFromFile(name, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Import Offer data
     * @param {OfferDataImport} offerDataImport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importOfferData(offerDataImport, options) {
        return exports.ImportRestApiFp(this.configuration).importOfferData(offerDataImport, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Import ongoing subscriptions
     * @param {string} [name]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importOngoingSubscriptions(name, file, options) {
        return exports.ImportRestApiFp(this.configuration).importOngoingSubscriptions(name, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Import Prestations data
     * @param {PrestationsDataImport} prestationsDataImport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportRestApi
     */
    importPrestationsData(prestationsDataImport, options) {
        return exports.ImportRestApiFp(this.configuration).importPrestationsData(prestationsDataImport, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ImportRestApi = ImportRestApi;
/**
 * OffresCommercialesRestApi - axios parameter creator
 * @export
 */
exports.OffresCommercialesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Paginated offers
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateDerniereModification'} [sortField]
         * @param {'DESC' | 'ASC'} [sortOrder]
         * @param {string} [search]
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageOffresCommercialesCommenceParNom: (page, size, sortField, sortOrder, search, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('afficherPageOffresCommercialesCommenceParNom', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('afficherPageOffresCommercialesCommenceParNom', 'size', size);
            const localVarPath = `/offres-commerciales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Archive the offer
         * @param {string} offreCommercialeId Offer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('archiveOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/archive`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Offer details
         * @param {string} offreCommercialeId Offer is
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('chargerOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary La finance lie l\'offre commerciale à un code souche
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeComplete} offreCommercialeComplete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOffreCommerciale: (offreCommercialeId, offreCommercialeComplete, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('completeOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            // verify required parameter 'offreCommercialeComplete' is not null or undefined
            common_1.assertParamExists('completeOffreCommerciale', 'offreCommercialeComplete', offreCommercialeComplete);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/complete`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(offreCommercialeComplete, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Config stellair offer connection
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {StellairConnectionDetailsForm} stellairConnectionDetailsForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configStellairOfferConnection: (offreCommercialeId, stellairConnectionDetailsForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('configStellairOfferConnection', 'offreCommercialeId', offreCommercialeId);
            // verify required parameter 'stellairConnectionDetailsForm' is not null or undefined
            common_1.assertParamExists('configStellairOfferConnection', 'stellairConnectionDetailsForm', stellairConnectionDetailsForm);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/stellair`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stellairConnectionDetailsForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create an Offer
         * @param {OffreCommercialeForm} offreCommercialeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffreCommerciale: (offreCommercialeForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeForm' is not null or undefined
            common_1.assertParamExists('createOffreCommerciale', 'offreCommercialeForm', offreCommercialeForm);
            const localVarPath = `/offres-commerciales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(offreCommercialeForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Duplicate the offer
         * @param {string} offreCommercialeId Offer id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('duplicateOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/duplicate`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get offer events
         * @param {string} offreCommercialeId Offer id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferEvents: (offreCommercialeId, page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('getOfferEvents', 'offreCommercialeId', offreCommercialeId);
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getOfferEvents', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getOfferEvents', 'size', size);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/events`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Afficher la liste des offres commerciales
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listerOffresCommerciales: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/offres-commerciales/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all commercial offers
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [etat]
         * @param {string} [nom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAll: (etat, nom, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/offres-commerciales/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (etat !== undefined) {
                localVarQueryParameter['etat'] = etat;
            }
            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Le management publie l\'offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('publishOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/publish`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supprimerOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('supprimerOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update offer name
         * @param {string} offreCommercialeId Offer id
         * @param {OfferNameForm} offerNameForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferName: (offreCommercialeId, offerNameForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('updateOfferName', 'offreCommercialeId', offreCommercialeId);
            // verify required parameter 'offerNameForm' is not null or undefined
            common_1.assertParamExists('updateOfferName', 'offerNameForm', offerNameForm);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/name`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(offerNameForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeFormUpdate} offreCommercialeFormUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffreCommerciale: (offreCommercialeId, offreCommercialeFormUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('updateOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            // verify required parameter 'offreCommercialeFormUpdate' is not null or undefined
            common_1.assertParamExists('updateOffreCommerciale', 'offreCommercialeFormUpdate', offreCommercialeFormUpdate);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(offreCommercialeFormUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Le management accepte la validation de la nouvelle offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOffreCommerciale: (offreCommercialeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offreCommercialeId' is not null or undefined
            common_1.assertParamExists('validateOffreCommerciale', 'offreCommercialeId', offreCommercialeId);
            const localVarPath = `/offres-commerciales/{offreCommercialeId}/validate`
                .replace(`{${"offreCommercialeId"}}`, encodeURIComponent(String(offreCommercialeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OffresCommercialesRestApi - functional programming interface
 * @export
 */
exports.OffresCommercialesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OffresCommercialesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Paginated offers
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateDerniereModification'} [sortField]
         * @param {'DESC' | 'ASC'} [sortOrder]
         * @param {string} [search]
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Archive the offer
         * @param {string} offreCommercialeId Offer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.archiveOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Offer details
         * @param {string} offreCommercialeId Offer is
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chargerOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary La finance lie l\'offre commerciale à un code souche
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeComplete} offreCommercialeComplete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Config stellair offer connection
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {StellairConnectionDetailsForm} stellairConnectionDetailsForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create an Offer
         * @param {OffreCommercialeForm} offreCommercialeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffreCommerciale(offreCommercialeForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOffreCommerciale(offreCommercialeForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Duplicate the offer
         * @param {string} offreCommercialeId Offer id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get offer events
         * @param {string} offreCommercialeId Offer id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferEvents(offreCommercialeId, page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOfferEvents(offreCommercialeId, page, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Afficher la liste des offres commerciales
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listerOffresCommerciales(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerOffresCommerciales(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all commercial offers
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [etat]
         * @param {string} [nom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAll(etat, nom, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerOffresCommercialesAll(etat, nom, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Le management publie l\'offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supprimerOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.supprimerOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update offer name
         * @param {string} offreCommercialeId Offer id
         * @param {OfferNameForm} offerNameForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferName(offreCommercialeId, offerNameForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOfferName(offreCommercialeId, offerNameForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeFormUpdate} offreCommercialeFormUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Le management accepte la validation de la nouvelle offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOffreCommerciale(offreCommercialeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateOffreCommerciale(offreCommercialeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OffresCommercialesRestApi - factory interface
 * @export
 */
exports.OffresCommercialesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OffresCommercialesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Paginated offers
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateDerniereModification'} [sortField]
         * @param {'DESC' | 'ASC'} [sortOrder]
         * @param {string} [search]
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options) {
            return localVarFp.afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Archive the offer
         * @param {string} offreCommercialeId Offer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.archiveOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Offer details
         * @param {string} offreCommercialeId Offer is
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.chargerOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary La finance lie l\'offre commerciale à un code souche
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeComplete} offreCommercialeComplete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options) {
            return localVarFp.completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Config stellair offer connection
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {StellairConnectionDetailsForm} stellairConnectionDetailsForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options) {
            return localVarFp.configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an Offer
         * @param {OffreCommercialeForm} offreCommercialeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffreCommerciale(offreCommercialeForm, options) {
            return localVarFp.createOffreCommerciale(offreCommercialeForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Duplicate the offer
         * @param {string} offreCommercialeId Offer id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.duplicateOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get offer events
         * @param {string} offreCommercialeId Offer id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferEvents(offreCommercialeId, page, size, options) {
            return localVarFp.getOfferEvents(offreCommercialeId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Afficher la liste des offres commerciales
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listerOffresCommerciales(options) {
            return localVarFp.listerOffresCommerciales(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all commercial offers
         * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [etat]
         * @param {string} [nom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerOffresCommercialesAll(etat, nom, options) {
            return localVarFp.listerOffresCommercialesAll(etat, nom, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Le management publie l\'offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.publishOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supprimerOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.supprimerOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update offer name
         * @param {string} offreCommercialeId Offer id
         * @param {OfferNameForm} offerNameForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferName(offreCommercialeId, offerNameForm, options) {
            return localVarFp.updateOfferName(offreCommercialeId, offerNameForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Offer
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {OffreCommercialeFormUpdate} offreCommercialeFormUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options) {
            return localVarFp.updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Le management accepte la validation de la nouvelle offre commerciale
         * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOffreCommerciale(offreCommercialeId, options) {
            return localVarFp.validateOffreCommerciale(offreCommercialeId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OffresCommercialesRestApi - object-oriented interface
 * @export
 * @class OffresCommercialesRestApi
 * @extends {BaseAPI}
 */
class OffresCommercialesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Paginated offers
     * @param {number} page
     * @param {number} size
     * @param {'nom' | 'dateDerniereModification'} [sortField]
     * @param {'DESC' | 'ASC'} [sortOrder]
     * @param {string} [search]
     * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).afficherPageOffresCommercialesCommenceParNom(page, size, sortField, sortOrder, search, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Archive the offer
     * @param {string} offreCommercialeId Offer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    archiveOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).archiveOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Offer details
     * @param {string} offreCommercialeId Offer is
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    chargerOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).chargerOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary La finance lie l\'offre commerciale à un code souche
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {OffreCommercialeComplete} offreCommercialeComplete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).completeOffreCommerciale(offreCommercialeId, offreCommercialeComplete, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Config stellair offer connection
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {StellairConnectionDetailsForm} stellairConnectionDetailsForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).configStellairOfferConnection(offreCommercialeId, stellairConnectionDetailsForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an Offer
     * @param {OffreCommercialeForm} offreCommercialeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    createOffreCommerciale(offreCommercialeForm, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).createOffreCommerciale(offreCommercialeForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Duplicate the offer
     * @param {string} offreCommercialeId Offer id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    duplicateOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).duplicateOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get offer events
     * @param {string} offreCommercialeId Offer id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    getOfferEvents(offreCommercialeId, page, size, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).getOfferEvents(offreCommercialeId, page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Afficher la liste des offres commerciales
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    listerOffresCommerciales(options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).listerOffresCommerciales(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all commercial offers
     * @param {'BROUILLON' | 'VALIDATION_ADV' | 'PRETE_A_ETRE_PUBLIEE' | 'PUBLIEE' | 'ARCHIVEE'} [etat]
     * @param {string} [nom]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    listerOffresCommercialesAll(etat, nom, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).listerOffresCommercialesAll(etat, nom, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Le management publie l\'offre commerciale
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    publishOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).publishOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Offer
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    supprimerOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).supprimerOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update offer name
     * @param {string} offreCommercialeId Offer id
     * @param {OfferNameForm} offerNameForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    updateOfferName(offreCommercialeId, offerNameForm, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).updateOfferName(offreCommercialeId, offerNameForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Offer
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {OffreCommercialeFormUpdate} offreCommercialeFormUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).updateOffreCommerciale(offreCommercialeId, offreCommercialeFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Le management accepte la validation de la nouvelle offre commerciale
     * @param {string} offreCommercialeId Identifiant de l\&#39;offre commerciale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffresCommercialesRestApi
     */
    validateOffreCommerciale(offreCommercialeId, options) {
        return exports.OffresCommercialesRestApiFp(this.configuration).validateOffreCommerciale(offreCommercialeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OffresCommercialesRestApi = OffresCommercialesRestApi;
/**
 * PaymentTermRestApi - axios parameter creator
 * @export
 */
exports.PaymentTermRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Available payment terms templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentTermTemplates: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payment/term/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentTermRestApi - functional programming interface
 * @export
 */
exports.PaymentTermRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PaymentTermRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Available payment terms templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentTermTemplates(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentTermTemplates(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentTermRestApi - factory interface
 * @export
 */
exports.PaymentTermRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PaymentTermRestApiFp(configuration);
    return {
        /**
         *
         * @summary Available payment terms templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentTermTemplates(options) {
            return localVarFp.paymentTermTemplates(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentTermRestApi - object-oriented interface
 * @export
 * @class PaymentTermRestApi
 * @extends {BaseAPI}
 */
class PaymentTermRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Available payment terms templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTermRestApi
     */
    paymentTermTemplates(options) {
        return exports.PaymentTermRestApiFp(this.configuration).paymentTermTemplates(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentTermRestApi = PaymentTermRestApi;
/**
 * PrestationsRestApi - axios parameter creator
 * @export
 */
exports.PrestationsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrestation: (prestationForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prestationForm' is not null or undefined
            common_1.assertParamExists('createPrestation', 'prestationForm', prestationForm);
            const localVarPath = `/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(prestationForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Supprimer une prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrestation: (prestationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prestationId' is not null or undefined
            common_1.assertParamExists('deletePrestation', 'prestationId', prestationId);
            const localVarPath = `/prestations/{prestationId}`
                .replace(`{${"prestationId"}}`, encodeURIComponent(String(prestationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get prestations in a paginated way
         * @param {number} page
         * @param {number} size
         * @param {'designation' | 'creePar'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [designation]
         * @param {string} [creePar]
         * @param {string} [multiColonnes] Recherche multi-colonnes, codeArticle ou designation ou creePar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagePrestations: (page, size, sortField, sortOrder, designation, creePar, multiColonnes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getPagePrestations', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getPagePrestations', 'size', size);
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('getPagePrestations', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('getPagePrestations', 'sortOrder', sortOrder);
            const localVarPath = `/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (designation !== undefined) {
                localVarQueryParameter['designation'] = designation;
            }
            if (creePar !== undefined) {
                localVarQueryParameter['creePar'] = creePar;
            }
            if (multiColonnes !== undefined) {
                localVarQueryParameter['multiColonnes'] = multiColonnes;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestation: (prestationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prestationId' is not null or undefined
            common_1.assertParamExists('getPrestation', 'prestationId', prestationId);
            const localVarPath = `/prestations/{prestationId}`
                .replace(`{${"prestationId"}}`, encodeURIComponent(String(prestationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Afficher la liste des prestations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/prestations/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrestation: (prestationId, prestationForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prestationId' is not null or undefined
            common_1.assertParamExists('updatePrestation', 'prestationId', prestationId);
            // verify required parameter 'prestationForm' is not null or undefined
            common_1.assertParamExists('updatePrestation', 'prestationForm', prestationForm);
            const localVarPath = `/prestations/{prestationId}`
                .replace(`{${"prestationId"}}`, encodeURIComponent(String(prestationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(prestationForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PrestationsRestApi - functional programming interface
 * @export
 */
exports.PrestationsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PrestationsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrestation(prestationForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPrestation(prestationForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Supprimer une prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrestation(prestationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePrestation(prestationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get prestations in a paginated way
         * @param {number} page
         * @param {number} size
         * @param {'designation' | 'creePar'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [designation]
         * @param {string} [creePar]
         * @param {string} [multiColonnes] Recherche multi-colonnes, codeArticle ou designation ou creePar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestation(prestationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPrestation(prestationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Afficher la liste des prestations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerPrestations(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrestation(prestationId, prestationForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePrestation(prestationId, prestationForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PrestationsRestApi - factory interface
 * @export
 */
exports.PrestationsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PrestationsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Create prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrestation(prestationForm, options) {
            return localVarFp.createPrestation(prestationForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Supprimer une prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrestation(prestationId, options) {
            return localVarFp.deletePrestation(prestationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get prestations in a paginated way
         * @param {number} page
         * @param {number} size
         * @param {'designation' | 'creePar'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [designation]
         * @param {string} [creePar]
         * @param {string} [multiColonnes] Recherche multi-colonnes, codeArticle ou designation ou creePar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options) {
            return localVarFp.getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestation(prestationId, options) {
            return localVarFp.getPrestation(prestationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Afficher la liste des prestations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerPrestations(options) {
            return localVarFp.listerPrestations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update prestation
         * @param {string} prestationId Identifiant de la prestation
         * @param {PrestationForm} prestationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrestation(prestationId, prestationForm, options) {
            return localVarFp.updatePrestation(prestationId, prestationForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PrestationsRestApi - object-oriented interface
 * @export
 * @class PrestationsRestApi
 * @extends {BaseAPI}
 */
class PrestationsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create prestation
     * @param {PrestationForm} prestationForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    createPrestation(prestationForm, options) {
        return exports.PrestationsRestApiFp(this.configuration).createPrestation(prestationForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Supprimer une prestation
     * @param {string} prestationId Identifiant de la prestation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    deletePrestation(prestationId, options) {
        return exports.PrestationsRestApiFp(this.configuration).deletePrestation(prestationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get prestations in a paginated way
     * @param {number} page
     * @param {number} size
     * @param {'designation' | 'creePar'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} [designation]
     * @param {string} [creePar]
     * @param {string} [multiColonnes] Recherche multi-colonnes, codeArticle ou designation ou creePar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options) {
        return exports.PrestationsRestApiFp(this.configuration).getPagePrestations(page, size, sortField, sortOrder, designation, creePar, multiColonnes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get prestation
     * @param {string} prestationId Identifiant de la prestation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    getPrestation(prestationId, options) {
        return exports.PrestationsRestApiFp(this.configuration).getPrestation(prestationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Afficher la liste des prestations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    listerPrestations(options) {
        return exports.PrestationsRestApiFp(this.configuration).listerPrestations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update prestation
     * @param {string} prestationId Identifiant de la prestation
     * @param {PrestationForm} prestationForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationsRestApi
     */
    updatePrestation(prestationId, prestationForm, options) {
        return exports.PrestationsRestApiFp(this.configuration).updatePrestation(prestationId, prestationForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PrestationsRestApi = PrestationsRestApi;
/**
 * ReportsRestApi - axios parameter creator
 * @export
 */
exports.ReportsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Reports
         * @param {string} billingOrderId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFseReport: (billingOrderId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingOrderId' is not null or undefined
            common_1.assertParamExists('downloadFseReport', 'billingOrderId', billingOrderId);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('downloadFseReport', 'key', key);
            const localVarPath = `/reports/fse/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (billingOrderId !== undefined) {
                localVarQueryParameter['billingOrderId'] = billingOrderId;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPrestationsReport: (fromDate, toDate, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fromDate' is not null or undefined
            common_1.assertParamExists('downloadPrestationsReport', 'fromDate', fromDate);
            // verify required parameter 'toDate' is not null or undefined
            common_1.assertParamExists('downloadPrestationsReport', 'toDate', toDate);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('downloadPrestationsReport', 'key', key);
            const localVarPath = `/reports/prestations/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString().substr(0, 10) :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString().substr(0, 10) :
                    toDate;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {string} savedReportId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSavedReport: (savedReportId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'savedReportId' is not null or undefined
            common_1.assertParamExists('downloadSavedReport', 'savedReportId', savedReportId);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('downloadSavedReport', 'key', key);
            const localVarPath = `/reports/saved/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (savedReportId !== undefined) {
                localVarQueryParameter['savedReportId'] = savedReportId;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download stellair clients usage report by report id
         * @param {string} id stellair usage report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStellairClientUsageReport: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('downloadStellairClientUsageReport', 'id', id);
            const localVarPath = `/reports/stellair/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {number} page
         * @param {number} size
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsommationFseReport: (page, size, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getConsommationFseReport', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getConsommationFseReport', 'size', size);
            const localVarPath = `/reports/consommation/fse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestationsReport: (fromDate, toDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fromDate' is not null or undefined
            common_1.assertParamExists('getPrestationsReport', 'fromDate', fromDate);
            // verify required parameter 'toDate' is not null or undefined
            common_1.assertParamExists('getPrestationsReport', 'toDate', toDate);
            const localVarPath = `/reports/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString().substr(0, 10) :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString().substr(0, 10) :
                    toDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of all stellair clients usage
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellairClientsUsageReport: (page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getStellairClientsUsageReport', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getStellairClientsUsageReport', 'size', size);
            const localVarPath = `/reports/stellair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a report for getting all billing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllBillingOrdersReport: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reports/billingOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllCustomersReport: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reports/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reports
         * @param {string} key Download key
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomersWithUsageReport: (key, username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('requestCustomersWithUsageReport', 'key', key);
            const localVarPath = `/reports/customers/usage/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Saved reports paginated
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportsPaginated: (page, size, sortField, sortOrder, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('savedReportsPaginated', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('savedReportsPaginated', 'size', size);
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('savedReportsPaginated', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('savedReportsPaginated', 'sortOrder', sortOrder);
            const localVarPath = `/reports/saved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReportsRestApi - functional programming interface
 * @export
 */
exports.ReportsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ReportsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Reports
         * @param {string} billingOrderId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFseReport(billingOrderId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadFseReport(billingOrderId, key, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPrestationsReport(fromDate, toDate, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadPrestationsReport(fromDate, toDate, key, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {string} savedReportId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSavedReport(savedReportId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadSavedReport(savedReportId, key, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Download stellair clients usage report by report id
         * @param {string} id stellair usage report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStellairClientUsageReport(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadStellairClientUsageReport(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {number} page
         * @param {number} size
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsommationFseReport(page, size, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConsommationFseReport(page, size, search, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestationsReport(fromDate, toDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPrestationsReport(fromDate, toDate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of all stellair clients usage
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellairClientsUsageReport(page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStellairClientsUsageReport(page, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a report for getting all billing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllBillingOrdersReport(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestAllBillingOrdersReport(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllCustomersReport(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestAllCustomersReport(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reports
         * @param {string} key Download key
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomersWithUsageReport(key, username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestCustomersWithUsageReport(key, username, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Saved reports paginated
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportsPaginated(page, size, sortField, sortOrder, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savedReportsPaginated(page, size, sortField, sortOrder, search, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ReportsRestApi - factory interface
 * @export
 */
exports.ReportsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ReportsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Reports
         * @param {string} billingOrderId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFseReport(billingOrderId, key, options) {
            return localVarFp.downloadFseReport(billingOrderId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPrestationsReport(fromDate, toDate, key, options) {
            return localVarFp.downloadPrestationsReport(fromDate, toDate, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {string} savedReportId
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSavedReport(savedReportId, key, options) {
            return localVarFp.downloadSavedReport(savedReportId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download stellair clients usage report by report id
         * @param {string} id stellair usage report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStellairClientUsageReport(id, options) {
            return localVarFp.downloadStellairClientUsageReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {number} page
         * @param {number} size
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsommationFseReport(page, size, search, options) {
            return localVarFp.getConsommationFseReport(page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrestationsReport(fromDate, toDate, options) {
            return localVarFp.getPrestationsReport(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of all stellair clients usage
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStellairClientsUsageReport(page, size, options) {
            return localVarFp.getStellairClientsUsageReport(page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a report for getting all billing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllBillingOrdersReport(options) {
            return localVarFp.requestAllBillingOrdersReport(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAllCustomersReport(options) {
            return localVarFp.requestAllCustomersReport(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports
         * @param {string} key Download key
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomersWithUsageReport(key, username, options) {
            return localVarFp.requestCustomersWithUsageReport(key, username, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Saved reports paginated
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportsPaginated(page, size, sortField, sortOrder, search, options) {
            return localVarFp.savedReportsPaginated(page, size, sortField, sortOrder, search, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportsRestApi - object-oriented interface
 * @export
 * @class ReportsRestApi
 * @extends {BaseAPI}
 */
class ReportsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Reports
     * @param {string} billingOrderId
     * @param {string} key Download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    downloadFseReport(billingOrderId, key, options) {
        return exports.ReportsRestApiFp(this.configuration).downloadFseReport(billingOrderId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {string} fromDate
     * @param {string} toDate
     * @param {string} key Download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    downloadPrestationsReport(fromDate, toDate, key, options) {
        return exports.ReportsRestApiFp(this.configuration).downloadPrestationsReport(fromDate, toDate, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {string} savedReportId
     * @param {string} key Download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    downloadSavedReport(savedReportId, key, options) {
        return exports.ReportsRestApiFp(this.configuration).downloadSavedReport(savedReportId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download stellair clients usage report by report id
     * @param {string} id stellair usage report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    downloadStellairClientUsageReport(id, options) {
        return exports.ReportsRestApiFp(this.configuration).downloadStellairClientUsageReport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {number} page
     * @param {number} size
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    getConsommationFseReport(page, size, search, options) {
        return exports.ReportsRestApiFp(this.configuration).getConsommationFseReport(page, size, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {string} fromDate
     * @param {string} toDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    getPrestationsReport(fromDate, toDate, options) {
        return exports.ReportsRestApiFp(this.configuration).getPrestationsReport(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of all stellair clients usage
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    getStellairClientsUsageReport(page, size, options) {
        return exports.ReportsRestApiFp(this.configuration).getStellairClientsUsageReport(page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a report for getting all billing orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    requestAllBillingOrdersReport(options) {
        return exports.ReportsRestApiFp(this.configuration).requestAllBillingOrdersReport(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    requestAllCustomersReport(options) {
        return exports.ReportsRestApiFp(this.configuration).requestAllCustomersReport(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports
     * @param {string} key Download key
     * @param {string} [username] Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    requestCustomersWithUsageReport(key, username, options) {
        return exports.ReportsRestApiFp(this.configuration).requestCustomersWithUsageReport(key, username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Saved reports paginated
     * @param {number} page
     * @param {number} size
     * @param {'nom' | 'dateCreation'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsRestApi
     */
    savedReportsPaginated(page, size, sortField, sortOrder, search, options) {
        return exports.ReportsRestApiFp(this.configuration).savedReportsPaginated(page, size, sortField, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ReportsRestApi = ReportsRestApi;
/**
 * SouchesRestApi - axios parameter creator
 * @export
 */
exports.SouchesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Afficher la liste des souches
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouches: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sageBase' is not null or undefined
            common_1.assertParamExists('listerSouches', 'sageBase', sageBase);
            const localVarPath = `/souches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SouchesRestApi - functional programming interface
 * @export
 */
exports.SouchesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SouchesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des souches
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouches(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerSouches(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SouchesRestApi - factory interface
 * @export
 */
exports.SouchesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SouchesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Afficher la liste des souches
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouches(sageBase, options) {
            return localVarFp.listerSouches(sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SouchesRestApi - object-oriented interface
 * @export
 * @class SouchesRestApi
 * @extends {BaseAPI}
 */
class SouchesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Afficher la liste des souches
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} sageBase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouchesRestApi
     */
    listerSouches(sageBase, options) {
        return exports.SouchesRestApiFp(this.configuration).listerSouches(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SouchesRestApi = SouchesRestApi;
/**
 * SouscriptionsRestApi - axios parameter creator
 * @export
 */
exports.SouscriptionsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Activate Stellair subscriptions
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {StellairSubscriptionForm} [stellairSubscriptionForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateStellairSubscription: (souscriptionId, stellairSubscriptionForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('activateStellairSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/stellair`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stellairSubscriptionForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Activate subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {ActivateSubscription} [activateSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSubscription: (souscriptionId, activateSubscription, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('activateSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/activate`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(activateSubscription, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subscriptions(paginated)
         * @param {number} page
         * @param {number} size
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageSouscriptions: (page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('afficherPageSouscriptions', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('afficherPageSouscriptions', 'size', size);
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('afficherPageSouscriptions', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('afficherPageSouscriptions', 'sortOrder', sortOrder);
            const localVarPath = `/souscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (numeroContrat !== undefined) {
                localVarQueryParameter['numeroContrat'] = numeroContrat;
            }
            if (startCreationDate !== undefined) {
                localVarQueryParameter['startCreationDate'] = (startCreationDate instanceof Date) ?
                    startCreationDate.toISOString().substr(0, 10) :
                    startCreationDate;
            }
            if (endCreationDate !== undefined) {
                localVarQueryParameter['endCreationDate'] = (endCreationDate instanceof Date) ?
                    endCreationDate.toISOString().substr(0, 10) :
                    endCreationDate;
            }
            if (startActivationDate !== undefined) {
                localVarQueryParameter['startActivationDate'] = (startActivationDate instanceof Date) ?
                    startActivationDate.toISOString().substr(0, 10) :
                    startActivationDate;
            }
            if (endActivationDate !== undefined) {
                localVarQueryParameter['endActivationDate'] = (endActivationDate instanceof Date) ?
                    endActivationDate.toISOString().substr(0, 10) :
                    endActivationDate;
            }
            if (startDebutDate !== undefined) {
                localVarQueryParameter['startDebutDate'] = (startDebutDate instanceof Date) ?
                    startDebutDate.toISOString().substr(0, 10) :
                    startDebutDate;
            }
            if (endDebutDate !== undefined) {
                localVarQueryParameter['endDebutDate'] = (endDebutDate instanceof Date) ?
                    endDebutDate.toISOString().substr(0, 10) :
                    endDebutDate;
            }
            if (startFinishDate !== undefined) {
                localVarQueryParameter['startFinishDate'] = (startFinishDate instanceof Date) ?
                    startFinishDate.toISOString().substr(0, 10) :
                    startFinishDate;
            }
            if (endFinishDate !== undefined) {
                localVarQueryParameter['endFinishDate'] = (endFinishDate instanceof Date) ?
                    endFinishDate.toISOString().substr(0, 10) :
                    endFinishDate;
            }
            if (startRenewalDate !== undefined) {
                localVarQueryParameter['startRenewalDate'] = (startRenewalDate instanceof Date) ?
                    startRenewalDate.toISOString().substr(0, 10) :
                    startRenewalDate;
            }
            if (endRenewalDate !== undefined) {
                localVarQueryParameter['endRenewalDate'] = (endRenewalDate instanceof Date) ?
                    endRenewalDate.toISOString().substr(0, 10) :
                    endRenewalDate;
            }
            if (startCancellationDate !== undefined) {
                localVarQueryParameter['startCancellationDate'] = (startCancellationDate instanceof Date) ?
                    startCancellationDate.toISOString().substr(0, 10) :
                    startCancellationDate;
            }
            if (endCancellationDate !== undefined) {
                localVarQueryParameter['endCancellationDate'] = (endCancellationDate instanceof Date) ?
                    endCancellationDate.toISOString().substr(0, 10) :
                    endCancellationDate;
            }
            if (thirdPartyPayer !== undefined) {
                localVarQueryParameter['thirdPartyPayer'] = thirdPartyPayer;
            }
            if (offer !== undefined) {
                localVarQueryParameter['offer'] = offer;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Ajouter une souscription à une offre commerciale
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajouterSouscription: (souscriptionForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionForm' is not null or undefined
            common_1.assertParamExists('ajouterSouscription', 'souscriptionForm', souscriptionForm);
            const localVarPath = `/souscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(souscriptionForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a list of subscription anmalies
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAnomaliesForSubscription: (souscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('allAnomaliesForSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/anomalies/all`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a list of uploaded files
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allContractFileForSubscription: (souscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('allContractFileForSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/all`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Change subscription status
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {SubscriptionStatusChange} [subscriptionStatusChange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionStatus: (souscriptionId, subscriptionStatusChange, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('changeSubscriptionStatus', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/status`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(subscriptionStatusChange, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subscription details
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerSouscription: (souscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('chargerSouscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContratSouscription: (souscriptionId, contractFileLinkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('deleteContratSouscription', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('deleteContratSouscription', 'contractFileLinkId', contractFileLinkId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: (souscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('deleteSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscription: (souscriptionId, contractFileLinkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscription', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscription', 'contractFileLinkId', contractFileLinkId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/download`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download contract file for subscription with download key
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKey: (souscriptionId, contractFileLinkId, key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKey', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKey', 'contractFileLinkId', contractFileLinkId);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('downloadContractFileForSubscriptionWithDownloadKey', 'key', key);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/downloadWithKey`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Export subscriptions
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} key Download key
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSouscriptions: (sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('exportSouscriptions', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('exportSouscriptions', 'sortOrder', sortOrder);
            // verify required parameter 'key' is not null or undefined
            common_1.assertParamExists('exportSouscriptions', 'key', key);
            const localVarPath = `/souscriptions/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (numeroContrat !== undefined) {
                localVarQueryParameter['numeroContrat'] = numeroContrat;
            }
            if (startCreationDate !== undefined) {
                localVarQueryParameter['startCreationDate'] = (startCreationDate instanceof Date) ?
                    startCreationDate.toISOString().substr(0, 10) :
                    startCreationDate;
            }
            if (endCreationDate !== undefined) {
                localVarQueryParameter['endCreationDate'] = (endCreationDate instanceof Date) ?
                    endCreationDate.toISOString().substr(0, 10) :
                    endCreationDate;
            }
            if (startActivationDate !== undefined) {
                localVarQueryParameter['startActivationDate'] = (startActivationDate instanceof Date) ?
                    startActivationDate.toISOString().substr(0, 10) :
                    startActivationDate;
            }
            if (endActivationDate !== undefined) {
                localVarQueryParameter['endActivationDate'] = (endActivationDate instanceof Date) ?
                    endActivationDate.toISOString().substr(0, 10) :
                    endActivationDate;
            }
            if (startDebutDate !== undefined) {
                localVarQueryParameter['startDebutDate'] = (startDebutDate instanceof Date) ?
                    startDebutDate.toISOString().substr(0, 10) :
                    startDebutDate;
            }
            if (endDebutDate !== undefined) {
                localVarQueryParameter['endDebutDate'] = (endDebutDate instanceof Date) ?
                    endDebutDate.toISOString().substr(0, 10) :
                    endDebutDate;
            }
            if (startFinishDate !== undefined) {
                localVarQueryParameter['startFinishDate'] = (startFinishDate instanceof Date) ?
                    startFinishDate.toISOString().substr(0, 10) :
                    startFinishDate;
            }
            if (endFinishDate !== undefined) {
                localVarQueryParameter['endFinishDate'] = (endFinishDate instanceof Date) ?
                    endFinishDate.toISOString().substr(0, 10) :
                    endFinishDate;
            }
            if (startRenewalDate !== undefined) {
                localVarQueryParameter['startRenewalDate'] = (startRenewalDate instanceof Date) ?
                    startRenewalDate.toISOString().substr(0, 10) :
                    startRenewalDate;
            }
            if (endRenewalDate !== undefined) {
                localVarQueryParameter['endRenewalDate'] = (endRenewalDate instanceof Date) ?
                    endRenewalDate.toISOString().substr(0, 10) :
                    endRenewalDate;
            }
            if (startCancellationDate !== undefined) {
                localVarQueryParameter['startCancellationDate'] = (startCancellationDate instanceof Date) ?
                    startCancellationDate.toISOString().substr(0, 10) :
                    startCancellationDate;
            }
            if (endCancellationDate !== undefined) {
                localVarQueryParameter['endCancellationDate'] = (endCancellationDate instanceof Date) ?
                    endCancellationDate.toISOString().substr(0, 10) :
                    endCancellationDate;
            }
            if (thirdPartyPayer !== undefined) {
                localVarQueryParameter['thirdPartyPayer'] = thirdPartyPayer;
            }
            if (offer !== undefined) {
                localVarQueryParameter['offer'] = offer;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingOrderEvents: (billingOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingOrderId' is not null or undefined
            common_1.assertParamExists('getBillingOrderEvents', 'billingOrderId', billingOrderId);
            const localVarPath = `/souscriptions/billingOrders/{billingOrderId}/events`
                .replace(`{${"billingOrderId"}}`, encodeURIComponent(String(billingOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get download key for downloading the contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscription: (souscriptionId, contractFileLinkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('getDownloadKeyForDownloadingContractFileForSubscription', 'souscriptionId', souscriptionId);
            // verify required parameter 'contractFileLinkId' is not null or undefined
            common_1.assertParamExists('getDownloadKeyForDownloadingContractFileForSubscription', 'contractFileLinkId', contractFileLinkId);
            const localVarPath = `/souscriptions/{souscriptionId}/contract/{contractFileLinkId}/getDownloadKey`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"contractFileLinkId"}}`, encodeURIComponent(String(contractFileLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrderDetails: (billingOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingOrderId' is not null or undefined
            common_1.assertParamExists('getSubscriptionBillingOrderDetails', 'billingOrderId', billingOrderId);
            const localVarPath = `/souscriptions/billingOrders/{billingOrderId}`
                .replace(`{${"billingOrderId"}}`, encodeURIComponent(String(billingOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get billing orders for selected subscription
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {'PLANIFIÉS' | 'TRANSMIS' | 'ANNULE'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrders: (souscriptionId, page, size, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('getSubscriptionBillingOrders', 'souscriptionId', souscriptionId);
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getSubscriptionBillingOrders', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getSubscriptionBillingOrders', 'size', size);
            // verify required parameter 'status' is not null or undefined
            common_1.assertParamExists('getSubscriptionBillingOrders', 'status', status);
            const localVarPath = `/souscriptions/{souscriptionId}/billingOrders`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subscription events
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionEvents: (souscriptionId, page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('getSubscriptionEvents', 'souscriptionId', souscriptionId);
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getSubscriptionEvents', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getSubscriptionEvents', 'size', size);
            const localVarPath = `/souscriptions/{souscriptionId}/events`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary lister les souscriptions
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptions: (fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/souscriptions/lister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierSouscription: (souscriptionId, souscriptionForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('modifierSouscription', 'souscriptionId', souscriptionId);
            // verify required parameter 'souscriptionForm' is not null or undefined
            common_1.assertParamExists('modifierSouscription', 'souscriptionForm', souscriptionForm);
            const localVarPath = `/souscriptions/{souscriptionId}`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(souscriptionForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Push to Sage BO with total = 0
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushBillingOrder: (billingOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingOrderId' is not null or undefined
            common_1.assertParamExists('pushBillingOrder', 'billingOrderId', billingOrderId);
            const localVarPath = `/souscriptions/billingOrders/{billingOrderId}/push`
                .replace(`{${"billingOrderId"}}`, encodeURIComponent(String(billingOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resolve anomalie
         * @param {string} souscriptionId Subscription id
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalieForSubscription: (souscriptionId, anomalieId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('resolveAnomalieForSubscription', 'souscriptionId', souscriptionId);
            // verify required parameter 'anomalieId' is not null or undefined
            common_1.assertParamExists('resolveAnomalieForSubscription', 'anomalieId', anomalieId);
            const localVarPath = `/souscriptions/{souscriptionId}/anomalies/{anomalieId}/resolve`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)))
                .replace(`{${"anomalieId"}}`, encodeURIComponent(String(anomalieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retry failed billing order
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedBillingOrder: (billingOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingOrderId' is not null or undefined
            common_1.assertParamExists('retryFailedBillingOrder', 'billingOrderId', billingOrderId);
            const localVarPath = `/souscriptions/billingOrders/{billingOrderId}/retry`
                .replace(`{${"billingOrderId"}}`, encodeURIComponent(String(billingOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Stellair account
         * @param {string} souscriptionId Subscription id
         * @param {StellairSubscriptionForm} stellairSubscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStellairAccount: (souscriptionId, stellairSubscriptionForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('updateStellairAccount', 'souscriptionId', souscriptionId);
            // verify required parameter 'stellairSubscriptionForm' is not null or undefined
            common_1.assertParamExists('updateStellairAccount', 'stellairSubscriptionForm', stellairSubscriptionForm);
            const localVarPath = `/souscriptions/{souscriptionId}/stellair`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stellairSubscriptionForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Upload contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscription: (souscriptionId, name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'souscriptionId' is not null or undefined
            common_1.assertParamExists('uploadContractFileForSubscription', 'souscriptionId', souscriptionId);
            const localVarPath = `/souscriptions/{souscriptionId}/uploadContract`
                .replace(`{${"souscriptionId"}}`, encodeURIComponent(String(souscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Uploading syntec indexes to subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadIndexesToSubscriptions: (name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/souscriptions/upload/indexes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SouscriptionsRestApi - functional programming interface
 * @export
 */
exports.SouscriptionsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SouscriptionsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Activate Stellair subscriptions
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {StellairSubscriptionForm} [stellairSubscriptionForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Activate subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {ActivateSubscription} [activateSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSubscription(souscriptionId, activateSubscription, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateSubscription(souscriptionId, activateSubscription, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subscriptions(paginated)
         * @param {number} page
         * @param {number} size
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Ajouter une souscription à une offre commerciale
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajouterSouscription(souscriptionForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ajouterSouscription(souscriptionForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a list of subscription anmalies
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAnomaliesForSubscription(souscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allAnomaliesForSubscription(souscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a list of uploaded files
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allContractFileForSubscription(souscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allContractFileForSubscription(souscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Change subscription status
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {SubscriptionStatusChange} [subscriptionStatusChange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subscription details
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerSouscription(souscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chargerSouscription(souscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContratSouscription(souscriptionId, contractFileLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteContratSouscription(souscriptionId, contractFileLinkId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription(souscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSubscription(souscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Download contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Download contract file for subscription with download key
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Export subscriptions
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} key Download key
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingOrderEvents(billingOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillingOrderEvents(billingOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get download key for downloading the contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrderDetails(billingOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionBillingOrderDetails(billingOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get billing orders for selected subscription
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {'PLANIFIÉS' | 'TRANSMIS' | 'ANNULE'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrders(souscriptionId, page, size, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionBillingOrders(souscriptionId, page, size, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get subscription events
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionEvents(souscriptionId, page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionEvents(souscriptionId, page, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary lister les souscriptions
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptions(fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listerSouscriptions(fields, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierSouscription(souscriptionId, souscriptionForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifierSouscription(souscriptionId, souscriptionForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Push to Sage BO with total = 0
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushBillingOrder(billingOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pushBillingOrder(billingOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resolve anomalie
         * @param {string} souscriptionId Subscription id
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalieForSubscription(souscriptionId, anomalieId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveAnomalieForSubscription(souscriptionId, anomalieId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retry failed billing order
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedBillingOrder(billingOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retryFailedBillingOrder(billingOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Stellair account
         * @param {string} souscriptionId Subscription id
         * @param {StellairSubscriptionForm} stellairSubscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStellairAccount(souscriptionId, stellairSubscriptionForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStellairAccount(souscriptionId, stellairSubscriptionForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Upload contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscription(souscriptionId, name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadContractFileForSubscription(souscriptionId, name, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Uploading syntec indexes to subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadIndexesToSubscriptions(name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadIndexesToSubscriptions(name, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SouscriptionsRestApi - factory interface
 * @export
 */
exports.SouscriptionsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SouscriptionsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Activate Stellair subscriptions
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {StellairSubscriptionForm} [stellairSubscriptionForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options) {
            return localVarFp.activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Activate subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {ActivateSubscription} [activateSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSubscription(souscriptionId, activateSubscription, options) {
            return localVarFp.activateSubscription(souscriptionId, activateSubscription, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subscriptions(paginated)
         * @param {number} page
         * @param {number} size
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options) {
            return localVarFp.afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Ajouter une souscription à une offre commerciale
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajouterSouscription(souscriptionForm, options) {
            return localVarFp.ajouterSouscription(souscriptionForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a list of subscription anmalies
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAnomaliesForSubscription(souscriptionId, options) {
            return localVarFp.allAnomaliesForSubscription(souscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a list of uploaded files
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allContractFileForSubscription(souscriptionId, options) {
            return localVarFp.allContractFileForSubscription(souscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change subscription status
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {SubscriptionStatusChange} [subscriptionStatusChange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options) {
            return localVarFp.changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subscription details
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargerSouscription(souscriptionId, options) {
            return localVarFp.chargerSouscription(souscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContratSouscription(souscriptionId, contractFileLinkId, options) {
            return localVarFp.deleteContratSouscription(souscriptionId, contractFileLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription(souscriptionId, options) {
            return localVarFp.deleteSubscription(souscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
            return localVarFp.downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download contract file for subscription with download key
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {string} key Download key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options) {
            return localVarFp.downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export subscriptions
         * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} key Download key
         * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
         * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
         * @param {string} [numeroContrat]
         * @param {string} [startCreationDate] start of creation starting
         * @param {string} [endCreationDate] end of creation starting
         * @param {string} [startActivationDate] start of activation date
         * @param {string} [endActivationDate] end of activation date
         * @param {string} [startDebutDate] start of activation starting
         * @param {string} [endDebutDate] end of activation starting
         * @param {string} [startFinishDate] Start of commitment(engagement)
         * @param {string} [endFinishDate] end of commitment(engagement)
         * @param {string} [startRenewalDate] Start of renewal
         * @param {string} [endRenewalDate] end of renewal
         * @param {string} [startCancellationDate] Start of cancellation
         * @param {string} [endCancellationDate] end of cancellation
         * @param {string} [thirdPartyPayer] Third party payer name or id
         * @param {string} [offer] offer name
         * @param {string} [username] Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options) {
            return localVarFp.exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingOrderEvents(billingOrderId, options) {
            return localVarFp.getBillingOrderEvents(billingOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get download key for downloading the contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} contractFileLinkId Identifiant de la contract link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
            return localVarFp.getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get billing orders details
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrderDetails(billingOrderId, options) {
            return localVarFp.getSubscriptionBillingOrderDetails(billingOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get billing orders for selected subscription
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {'PLANIFIÉS' | 'TRANSMIS' | 'ANNULE'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBillingOrders(souscriptionId, page, size, status, options) {
            return localVarFp.getSubscriptionBillingOrders(souscriptionId, page, size, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subscription events
         * @param {string} souscriptionId Subscription id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionEvents(souscriptionId, page, size, options) {
            return localVarFp.getSubscriptionEvents(souscriptionId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary lister les souscriptions
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listerSouscriptions(fields, options) {
            return localVarFp.listerSouscriptions(fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a subscription
         * @param {string} souscriptionId Subscription Id
         * @param {SouscriptionForm} souscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierSouscription(souscriptionId, souscriptionForm, options) {
            return localVarFp.modifierSouscription(souscriptionId, souscriptionForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Push to Sage BO with total = 0
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushBillingOrder(billingOrderId, options) {
            return localVarFp.pushBillingOrder(billingOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resolve anomalie
         * @param {string} souscriptionId Subscription id
         * @param {string} anomalieId Anomalie id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAnomalieForSubscription(souscriptionId, anomalieId, options) {
            return localVarFp.resolveAnomalieForSubscription(souscriptionId, anomalieId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry failed billing order
         * @param {string} billingOrderId Billing Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedBillingOrder(billingOrderId, options) {
            return localVarFp.retryFailedBillingOrder(billingOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Stellair account
         * @param {string} souscriptionId Subscription id
         * @param {StellairSubscriptionForm} stellairSubscriptionForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStellairAccount(souscriptionId, stellairSubscriptionForm, options) {
            return localVarFp.updateStellairAccount(souscriptionId, stellairSubscriptionForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload contract file for subscription
         * @param {string} souscriptionId Identifiant de la souscription
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContractFileForSubscription(souscriptionId, name, file, options) {
            return localVarFp.uploadContractFileForSubscription(souscriptionId, name, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Uploading syntec indexes to subscriptions
         * @param {string} [name]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadIndexesToSubscriptions(name, file, options) {
            return localVarFp.uploadIndexesToSubscriptions(name, file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SouscriptionsRestApi - object-oriented interface
 * @export
 * @class SouscriptionsRestApi
 * @extends {BaseAPI}
 */
class SouscriptionsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Activate Stellair subscriptions
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {StellairSubscriptionForm} [stellairSubscriptionForm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).activateStellairSubscription(souscriptionId, stellairSubscriptionForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Activate subscription
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {ActivateSubscription} [activateSubscription]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    activateSubscription(souscriptionId, activateSubscription, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).activateSubscription(souscriptionId, activateSubscription, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subscriptions(paginated)
     * @param {number} page
     * @param {number} size
     * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} [search] Recherche multi-colonnes, client, numéro client ou numéro contrat
     * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
     * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
     * @param {string} [numeroContrat]
     * @param {string} [startCreationDate] start of creation starting
     * @param {string} [endCreationDate] end of creation starting
     * @param {string} [startActivationDate] start of activation date
     * @param {string} [endActivationDate] end of activation date
     * @param {string} [startDebutDate] start of activation starting
     * @param {string} [endDebutDate] end of activation starting
     * @param {string} [startFinishDate] Start of commitment(engagement)
     * @param {string} [endFinishDate] end of commitment(engagement)
     * @param {string} [startRenewalDate] Start of renewal
     * @param {string} [endRenewalDate] end of renewal
     * @param {string} [startCancellationDate] Start of cancellation
     * @param {string} [endCancellationDate] end of cancellation
     * @param {string} [thirdPartyPayer] Third party payer name or id
     * @param {string} [offer] offer name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).afficherPageSouscriptions(page, size, sortField, sortOrder, search, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Ajouter une souscription à une offre commerciale
     * @param {SouscriptionForm} souscriptionForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    ajouterSouscription(souscriptionForm, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).ajouterSouscription(souscriptionForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a list of subscription anmalies
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    allAnomaliesForSubscription(souscriptionId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).allAnomaliesForSubscription(souscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a list of uploaded files
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    allContractFileForSubscription(souscriptionId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).allContractFileForSubscription(souscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Change subscription status
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {SubscriptionStatusChange} [subscriptionStatusChange]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).changeSubscriptionStatus(souscriptionId, subscriptionStatusChange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subscription details
     * @param {string} souscriptionId Subscription Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    chargerSouscription(souscriptionId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).chargerSouscription(souscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete contract file for subscription
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    deleteContratSouscription(souscriptionId, contractFileLinkId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).deleteContratSouscription(souscriptionId, contractFileLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a subscription
     * @param {string} souscriptionId Subscription Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    deleteSubscription(souscriptionId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).deleteSubscription(souscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download contract file for subscription
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).downloadContractFileForSubscription(souscriptionId, contractFileLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download contract file for subscription with download key
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract link
     * @param {string} key Download key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).downloadContractFileForSubscriptionWithDownloadKey(souscriptionId, contractFileLinkId, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Export subscriptions
     * @param {'activationDate' | 'dateDebut' | 'dateRenew' | 'terminateDate' | 'dateFin' | 'clientName' | 'thirdPartyPayerName' | 'dateCreation'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} key Download key
     * @param {string} [client] Recherche multi-colonnes, client, numéro client ou numéro contrat
     * @param {'INCOMPLETE' | 'ANOMALIE' | 'ACTIVE' | 'CANCEL' | 'CLOSED' | 'SCHEDULED_START' | 'TERMINATION_PLANNED'} [status] Filter by subscription status. It can be filled with multiple statuses and a comma between them
     * @param {string} [numeroContrat]
     * @param {string} [startCreationDate] start of creation starting
     * @param {string} [endCreationDate] end of creation starting
     * @param {string} [startActivationDate] start of activation date
     * @param {string} [endActivationDate] end of activation date
     * @param {string} [startDebutDate] start of activation starting
     * @param {string} [endDebutDate] end of activation starting
     * @param {string} [startFinishDate] Start of commitment(engagement)
     * @param {string} [endFinishDate] end of commitment(engagement)
     * @param {string} [startRenewalDate] Start of renewal
     * @param {string} [endRenewalDate] end of renewal
     * @param {string} [startCancellationDate] Start of cancellation
     * @param {string} [endCancellationDate] end of cancellation
     * @param {string} [thirdPartyPayer] Third party payer name or id
     * @param {string} [offer] offer name
     * @param {string} [username] Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).exportSouscriptions(sortField, sortOrder, key, client, status, numeroContrat, startCreationDate, endCreationDate, startActivationDate, endActivationDate, startDebutDate, endDebutDate, startFinishDate, endFinishDate, startRenewalDate, endRenewalDate, startCancellationDate, endCancellationDate, thirdPartyPayer, offer, username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get billing orders details
     * @param {string} billingOrderId Billing Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    getBillingOrderEvents(billingOrderId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).getBillingOrderEvents(billingOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get download key for downloading the contract file for subscription
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} contractFileLinkId Identifiant de la contract link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).getDownloadKeyForDownloadingContractFileForSubscription(souscriptionId, contractFileLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get billing orders details
     * @param {string} billingOrderId Billing Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    getSubscriptionBillingOrderDetails(billingOrderId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).getSubscriptionBillingOrderDetails(billingOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get billing orders for selected subscription
     * @param {string} souscriptionId Subscription id
     * @param {number} page
     * @param {number} size
     * @param {'PLANIFIÉS' | 'TRANSMIS' | 'ANNULE'} status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    getSubscriptionBillingOrders(souscriptionId, page, size, status, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).getSubscriptionBillingOrders(souscriptionId, page, size, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subscription events
     * @param {string} souscriptionId Subscription id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    getSubscriptionEvents(souscriptionId, page, size, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).getSubscriptionEvents(souscriptionId, page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary lister les souscriptions
     * @param {string} [fields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    listerSouscriptions(fields, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).listerSouscriptions(fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a subscription
     * @param {string} souscriptionId Subscription Id
     * @param {SouscriptionForm} souscriptionForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    modifierSouscription(souscriptionId, souscriptionForm, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).modifierSouscription(souscriptionId, souscriptionForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Push to Sage BO with total = 0
     * @param {string} billingOrderId Billing Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    pushBillingOrder(billingOrderId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).pushBillingOrder(billingOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resolve anomalie
     * @param {string} souscriptionId Subscription id
     * @param {string} anomalieId Anomalie id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    resolveAnomalieForSubscription(souscriptionId, anomalieId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).resolveAnomalieForSubscription(souscriptionId, anomalieId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retry failed billing order
     * @param {string} billingOrderId Billing Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    retryFailedBillingOrder(billingOrderId, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).retryFailedBillingOrder(billingOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Stellair account
     * @param {string} souscriptionId Subscription id
     * @param {StellairSubscriptionForm} stellairSubscriptionForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    updateStellairAccount(souscriptionId, stellairSubscriptionForm, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).updateStellairAccount(souscriptionId, stellairSubscriptionForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upload contract file for subscription
     * @param {string} souscriptionId Identifiant de la souscription
     * @param {string} [name]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    uploadContractFileForSubscription(souscriptionId, name, file, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).uploadContractFileForSubscription(souscriptionId, name, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Uploading syntec indexes to subscriptions
     * @param {string} [name]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouscriptionsRestApi
     */
    uploadIndexesToSubscriptions(name, file, options) {
        return exports.SouscriptionsRestApiFp(this.configuration).uploadIndexesToSubscriptions(name, file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SouscriptionsRestApi = SouscriptionsRestApi;
/**
 * SyntecIndexRestApi - axios parameter creator
 * @export
 */
exports.SyntecIndexRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add a new syntec index
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIndex: (syntecIndexForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syntecIndexForm' is not null or undefined
            common_1.assertParamExists('addIndex', 'syntecIndexForm', syntecIndexForm);
            const localVarPath = `/syntec/indexes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(syntecIndexForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a syntec index
         * @param {string} indexId Index id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndex: (indexId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'indexId' is not null or undefined
            common_1.assertParamExists('deleteIndex', 'indexId', indexId);
            const localVarPath = `/syntec/indexes/{indexId}`
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get list of syntec indexes by type of duration(month or year)
         * @param {'MONTH' | 'YEAR'} type Duration type
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSyntecIndexesByType: (type, page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            common_1.assertParamExists('getAllSyntecIndexesByType', 'type', type);
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getAllSyntecIndexesByType', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getAllSyntecIndexesByType', 'size', size);
            const localVarPath = `/syntec/indexes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a new syntec index
         * @param {string} indexId Index Id
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndex: (indexId, syntecIndexForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'indexId' is not null or undefined
            common_1.assertParamExists('updateIndex', 'indexId', indexId);
            // verify required parameter 'syntecIndexForm' is not null or undefined
            common_1.assertParamExists('updateIndex', 'syntecIndexForm', syntecIndexForm);
            const localVarPath = `/syntec/indexes/{indexId}`
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(syntecIndexForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SyntecIndexRestApi - functional programming interface
 * @export
 */
exports.SyntecIndexRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SyntecIndexRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new syntec index
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIndex(syntecIndexForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addIndex(syntecIndexForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a syntec index
         * @param {string} indexId Index id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndex(indexId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteIndex(indexId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get list of syntec indexes by type of duration(month or year)
         * @param {'MONTH' | 'YEAR'} type Duration type
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSyntecIndexesByType(type, page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllSyntecIndexesByType(type, page, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a new syntec index
         * @param {string} indexId Index Id
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndex(indexId, syntecIndexForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIndex(indexId, syntecIndexForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SyntecIndexRestApi - factory interface
 * @export
 */
exports.SyntecIndexRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SyntecIndexRestApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new syntec index
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIndex(syntecIndexForm, options) {
            return localVarFp.addIndex(syntecIndexForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a syntec index
         * @param {string} indexId Index id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndex(indexId, options) {
            return localVarFp.deleteIndex(indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of syntec indexes by type of duration(month or year)
         * @param {'MONTH' | 'YEAR'} type Duration type
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSyntecIndexesByType(type, page, size, options) {
            return localVarFp.getAllSyntecIndexesByType(type, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a new syntec index
         * @param {string} indexId Index Id
         * @param {SyntecIndexForm} syntecIndexForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndex(indexId, syntecIndexForm, options) {
            return localVarFp.updateIndex(indexId, syntecIndexForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SyntecIndexRestApi - object-oriented interface
 * @export
 * @class SyntecIndexRestApi
 * @extends {BaseAPI}
 */
class SyntecIndexRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add a new syntec index
     * @param {SyntecIndexForm} syntecIndexForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyntecIndexRestApi
     */
    addIndex(syntecIndexForm, options) {
        return exports.SyntecIndexRestApiFp(this.configuration).addIndex(syntecIndexForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a syntec index
     * @param {string} indexId Index id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyntecIndexRestApi
     */
    deleteIndex(indexId, options) {
        return exports.SyntecIndexRestApiFp(this.configuration).deleteIndex(indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of syntec indexes by type of duration(month or year)
     * @param {'MONTH' | 'YEAR'} type Duration type
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyntecIndexRestApi
     */
    getAllSyntecIndexesByType(type, page, size, options) {
        return exports.SyntecIndexRestApiFp(this.configuration).getAllSyntecIndexesByType(type, page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a new syntec index
     * @param {string} indexId Index Id
     * @param {SyntecIndexForm} syntecIndexForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyntecIndexRestApi
     */
    updateIndex(indexId, syntecIndexForm, options) {
        return exports.SyntecIndexRestApiFp(this.configuration).updateIndex(indexId, syntecIndexForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SyntecIndexRestApi = SyntecIndexRestApi;
/**
 * TeamsContactsRestApi - axios parameter creator
 * @export
 */
exports.TeamsContactsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add Contact to the Client
         * @param {string} clientId Client id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientContact: (clientId, contactForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('addClientContact', 'clientId', clientId);
            // verify required parameter 'contactForm' is not null or undefined
            common_1.assertParamExists('addClientContact', 'contactForm', contactForm);
            const localVarPath = `/teams/client/{clientId}/contacts`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(contactForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of all client contacts
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientContactsList: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('allClientContactsList', 'clientId', clientId);
            const localVarPath = `/teams/client/{clientId}/contacts/all`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientContact: (clientId, contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('deleteClientContact', 'clientId', clientId);
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('deleteClientContact', 'contactId', contactId);
            const localVarPath = `/teams/client/{clientId}/contacts/{contactId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of all subscriptions by client number
         * @param {string} clientId Client Number
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByClientNumber: (clientId, page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('getAllSubscriptionsByClientNumber', 'clientId', clientId);
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('getAllSubscriptionsByClientNumber', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('getAllSubscriptionsByClientNumber', 'size', size);
            const localVarPath = `/teams/client/{clientId}/subscriptions`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Clients Contact by id
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContact: (clientId, contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('getClientContact', 'clientId', clientId);
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('getClientContact', 'contactId', contactId);
            const localVarPath = `/teams/client/{clientId}/contacts/{contactId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientContact: (clientId, contactId, contactForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('updateClientContact', 'clientId', clientId);
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('updateClientContact', 'contactId', contactId);
            // verify required parameter 'contactForm' is not null or undefined
            common_1.assertParamExists('updateClientContact', 'contactForm', contactForm);
            const localVarPath = `/teams/client/{clientId}/contacts/{contactId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(contactForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TeamsContactsRestApi - functional programming interface
 * @export
 */
exports.TeamsContactsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TeamsContactsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add Contact to the Client
         * @param {string} clientId Client id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientContact(clientId, contactForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addClientContact(clientId, contactForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of all client contacts
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientContactsList(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allClientContactsList(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientContact(clientId, contactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteClientContact(clientId, contactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of all subscriptions by client number
         * @param {string} clientId Client Number
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByClientNumber(clientId, page, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllSubscriptionsByClientNumber(clientId, page, size, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Clients Contact by id
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContact(clientId, contactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClientContact(clientId, contactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientContact(clientId, contactId, contactForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateClientContact(clientId, contactId, contactForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TeamsContactsRestApi - factory interface
 * @export
 */
exports.TeamsContactsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TeamsContactsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Add Contact to the Client
         * @param {string} clientId Client id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientContact(clientId, contactForm, options) {
            return localVarFp.addClientContact(clientId, contactForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of all client contacts
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientContactsList(clientId, options) {
            return localVarFp.allClientContactsList(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientContact(clientId, contactId, options) {
            return localVarFp.deleteClientContact(clientId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of all subscriptions by client number
         * @param {string} clientId Client Number
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByClientNumber(clientId, page, size, options) {
            return localVarFp.getAllSubscriptionsByClientNumber(clientId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Clients Contact by id
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContact(clientId, contactId, options) {
            return localVarFp.getClientContact(clientId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Clients Contact
         * @param {string} clientId Client id
         * @param {string} contactId Contact id
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientContact(clientId, contactId, contactForm, options) {
            return localVarFp.updateClientContact(clientId, contactId, contactForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TeamsContactsRestApi - object-oriented interface
 * @export
 * @class TeamsContactsRestApi
 * @extends {BaseAPI}
 */
class TeamsContactsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add Contact to the Client
     * @param {string} clientId Client id
     * @param {ContactForm} contactForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    addClientContact(clientId, contactForm, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).addClientContact(clientId, contactForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of all client contacts
     * @param {string} clientId Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    allClientContactsList(clientId, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).allClientContactsList(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Clients Contact
     * @param {string} clientId Client id
     * @param {string} contactId Contact id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    deleteClientContact(clientId, contactId, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).deleteClientContact(clientId, contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of all subscriptions by client number
     * @param {string} clientId Client Number
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    getAllSubscriptionsByClientNumber(clientId, page, size, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).getAllSubscriptionsByClientNumber(clientId, page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Clients Contact by id
     * @param {string} clientId Client id
     * @param {string} contactId Contact id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    getClientContact(clientId, contactId, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).getClientContact(clientId, contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Clients Contact
     * @param {string} clientId Client id
     * @param {string} contactId Contact id
     * @param {ContactForm} contactForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsContactsRestApi
     */
    updateClientContact(clientId, contactId, contactForm, options) {
        return exports.TeamsContactsRestApiFp(this.configuration).updateClientContact(clientId, contactId, contactForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TeamsContactsRestApi = TeamsContactsRestApi;
/**
 * TeamsPropertiesRestApi - axios parameter creator
 * @export
 */
exports.TeamsPropertiesRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get list of all SAGE departments
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDepartments: (fromSage, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/teams/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromSage !== undefined) {
                localVarQueryParameter['fromSage'] = fromSage;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get list of all SAGE customers
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageCustomers: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/teams/sage/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get list of all SAGE contact types
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTypeOfContacts: (fromSage, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/teams/type-of-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fromSage !== undefined) {
                localVarQueryParameter['fromSage'] = fromSage;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TeamsPropertiesRestApi - functional programming interface
 * @export
 */
exports.TeamsPropertiesRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TeamsPropertiesRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get list of all SAGE departments
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDepartments(fromSage, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allDepartments(fromSage, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get list of all SAGE customers
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageCustomers(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allSageCustomers(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get list of all SAGE contact types
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTypeOfContacts(fromSage, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allTypeOfContacts(fromSage, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TeamsPropertiesRestApi - factory interface
 * @export
 */
exports.TeamsPropertiesRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TeamsPropertiesRestApiFp(configuration);
    return {
        /**
         *
         * @summary Get list of all SAGE departments
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDepartments(fromSage, sageBase, options) {
            return localVarFp.allDepartments(fromSage, sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of all SAGE customers
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageCustomers(sageBase, options) {
            return localVarFp.allSageCustomers(sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of all SAGE contact types
         * @param {boolean} [fromSage]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTypeOfContacts(fromSage, sageBase, options) {
            return localVarFp.allTypeOfContacts(fromSage, sageBase, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TeamsPropertiesRestApi - object-oriented interface
 * @export
 * @class TeamsPropertiesRestApi
 * @extends {BaseAPI}
 */
class TeamsPropertiesRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get list of all SAGE departments
     * @param {boolean} [fromSage]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsPropertiesRestApi
     */
    allDepartments(fromSage, sageBase, options) {
        return exports.TeamsPropertiesRestApiFp(this.configuration).allDepartments(fromSage, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of all SAGE customers
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsPropertiesRestApi
     */
    allSageCustomers(sageBase, options) {
        return exports.TeamsPropertiesRestApiFp(this.configuration).allSageCustomers(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of all SAGE contact types
     * @param {boolean} [fromSage]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsPropertiesRestApi
     */
    allTypeOfContacts(fromSage, sageBase, options) {
        return exports.TeamsPropertiesRestApiFp(this.configuration).allTypeOfContacts(fromSage, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TeamsPropertiesRestApi = TeamsPropertiesRestApi;
/**
 * TeamsRestApi - axios parameter creator
 * @export
 */
exports.TeamsRestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add client group
         * @param {ClientGroupForm} clientGroupForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientGroup: (clientGroupForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientGroupForm' is not null or undefined
            common_1.assertParamExists('addClientGroup', 'clientGroupForm', clientGroupForm);
            const localVarPath = `/teams/client/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(clientGroupForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add Client Organization
         * @param {ClientOrganizationForm} clientOrganizationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientOrganization: (clientOrganizationForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientOrganizationForm' is not null or undefined
            common_1.assertParamExists('addClientOrganization', 'clientOrganizationForm', clientOrganizationForm);
            const localVarPath = `/teams/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(clientOrganizationForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add Delivery Address
         * @param {string} clientId Client id
         * @param {DeliveryAddressForm} deliveryAddressForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryAddress: (clientId, deliveryAddressForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('addDeliveryAddress', 'clientId', clientId);
            // verify required parameter 'deliveryAddressForm' is not null or undefined
            common_1.assertParamExists('addDeliveryAddress', 'deliveryAddressForm', deliveryAddressForm);
            const localVarPath = `/teams/client/{clientId}/delivery-addresses`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deliveryAddressForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of client teams
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [nom]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientList: (sortField, sortOrder, nom, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('allClientList', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('allClientList', 'sortOrder', sortOrder);
            const localVarPath = `/teams/client/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of client groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGroupList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/teams/client/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary All Sage users
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageUsers: (sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/teams/sage/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Paginated client teams
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientTeamsPaginated: (page, size, sortField, sortOrder, search, sageBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            common_1.assertParamExists('clientTeamsPaginated', 'page', page);
            // verify required parameter 'size' is not null or undefined
            common_1.assertParamExists('clientTeamsPaginated', 'size', size);
            // verify required parameter 'sortField' is not null or undefined
            common_1.assertParamExists('clientTeamsPaginated', 'sortField', sortField);
            // verify required parameter 'sortOrder' is not null or undefined
            common_1.assertParamExists('clientTeamsPaginated', 'sortOrder', sortOrder);
            const localVarPath = `/teams/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (sageBase !== undefined) {
                localVarQueryParameter['sageBase'] = sageBase;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Stellair account
         * @param {string} clientId Client id
         * @param {StellairAccountForm} stellairAccountForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStellairAccount: (clientId, stellairAccountForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('createStellairAccount', 'clientId', clientId);
            // verify required parameter 'stellairAccountForm' is not null or undefined
            common_1.assertParamExists('createStellairAccount', 'stellairAccountForm', stellairAccountForm);
            const localVarPath = `/teams/client/{clientId}/stellair`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stellairAccountForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary All delivery addresses
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryAddressesAll: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('deliveryAddressesAll', 'clientId', clientId);
            const localVarPath = `/teams/client/{clientId}/delivery-addresses`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Duplicate the client
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateClient: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('duplicateClient', 'clientId', clientId);
            const localVarPath = `/teams/client/{clientId}/duplicate`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Client Organization
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganization: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('getClientOrganization', 'clientId', clientId);
            const localVarPath = `/teams/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Client Organization by Sage Numero Client
         * @param {string} numeroClient Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganizationByNumeroClient: (numeroClient, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'numeroClient' is not null or undefined
            common_1.assertParamExists('getClientOrganizationByNumeroClient', 'numeroClient', numeroClient);
            const localVarPath = `/teams/client/numeroClient/{numeroClient}`
                .replace(`{${"numeroClient"}}`, encodeURIComponent(String(numeroClient)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddress: (clientId, deliveryAddressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('getDeliveryAddress', 'clientId', clientId);
            // verify required parameter 'deliveryAddressId' is not null or undefined
            common_1.assertParamExists('getDeliveryAddress', 'deliveryAddressId', deliveryAddressId);
            const localVarPath = `/teams/client/{clientId}/delivery-addresses/{deliveryAddressId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"deliveryAddressId"}}`, encodeURIComponent(String(deliveryAddressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Client Organization
         * @param {string} clientId Client id
         * @param {ClientOrganizationFormUpdate} [clientOrganizationFormUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientOrganization: (clientId, clientOrganizationFormUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('updateClientOrganization', 'clientId', clientId);
            const localVarPath = `/teams/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(clientOrganizationFormUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {DeliveryAddressForm} [deliveryAddressForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryAddress: (clientId, deliveryAddressId, deliveryAddressForm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            common_1.assertParamExists('updateDeliveryAddress', 'clientId', clientId);
            // verify required parameter 'deliveryAddressId' is not null or undefined
            common_1.assertParamExists('updateDeliveryAddress', 'deliveryAddressId', deliveryAddressId);
            const localVarPath = `/teams/client/{clientId}/delivery-addresses/{deliveryAddressId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"deliveryAddressId"}}`, encodeURIComponent(String(deliveryAddressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication gatewayapi-auth-aad required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deliveryAddressForm, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TeamsRestApi - functional programming interface
 * @export
 */
exports.TeamsRestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TeamsRestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add client group
         * @param {ClientGroupForm} clientGroupForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientGroup(clientGroupForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addClientGroup(clientGroupForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add Client Organization
         * @param {ClientOrganizationForm} clientOrganizationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientOrganization(clientOrganizationForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addClientOrganization(clientOrganizationForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add Delivery Address
         * @param {string} clientId Client id
         * @param {DeliveryAddressForm} deliveryAddressForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryAddress(clientId, deliveryAddressForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addDeliveryAddress(clientId, deliveryAddressForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of client teams
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [nom]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientList(sortField, sortOrder, nom, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allClientList(sortField, sortOrder, nom, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of client groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGroupList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allGroupList(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary All Sage users
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageUsers(sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.allSageUsers(sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Paginated client teams
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Stellair account
         * @param {string} clientId Client id
         * @param {StellairAccountForm} stellairAccountForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStellairAccount(clientId, stellairAccountForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStellairAccount(clientId, stellairAccountForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary All delivery addresses
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryAddressesAll(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deliveryAddressesAll(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Duplicate the client
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateClient(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.duplicateClient(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Client Organization
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganization(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClientOrganization(clientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Client Organization by Sage Numero Client
         * @param {string} numeroClient Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganizationByNumeroClient(numeroClient, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClientOrganizationByNumeroClient(numeroClient, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddress(clientId, deliveryAddressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeliveryAddress(clientId, deliveryAddressId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Client Organization
         * @param {string} clientId Client id
         * @param {ClientOrganizationFormUpdate} [clientOrganizationFormUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientOrganization(clientId, clientOrganizationFormUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateClientOrganization(clientId, clientOrganizationFormUpdate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {DeliveryAddressForm} [deliveryAddressForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TeamsRestApi - factory interface
 * @export
 */
exports.TeamsRestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TeamsRestApiFp(configuration);
    return {
        /**
         *
         * @summary Add client group
         * @param {ClientGroupForm} clientGroupForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientGroup(clientGroupForm, options) {
            return localVarFp.addClientGroup(clientGroupForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add Client Organization
         * @param {ClientOrganizationForm} clientOrganizationForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientOrganization(clientOrganizationForm, options) {
            return localVarFp.addClientOrganization(clientOrganizationForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add Delivery Address
         * @param {string} clientId Client id
         * @param {DeliveryAddressForm} deliveryAddressForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryAddress(clientId, deliveryAddressForm, options) {
            return localVarFp.addDeliveryAddress(clientId, deliveryAddressForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of client teams
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [nom]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allClientList(sortField, sortOrder, nom, sageBase, options) {
            return localVarFp.allClientList(sortField, sortOrder, nom, sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of client groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGroupList(options) {
            return localVarFp.allGroupList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary All Sage users
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSageUsers(sageBase, options) {
            return localVarFp.allSageUsers(sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Paginated client teams
         * @param {number} page
         * @param {number} size
         * @param {'nom' | 'dateCreation'} sortField
         * @param {'DESC' | 'ASC'} sortOrder
         * @param {string} [search]
         * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options) {
            return localVarFp.clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Stellair account
         * @param {string} clientId Client id
         * @param {StellairAccountForm} stellairAccountForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStellairAccount(clientId, stellairAccountForm, options) {
            return localVarFp.createStellairAccount(clientId, stellairAccountForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary All delivery addresses
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryAddressesAll(clientId, options) {
            return localVarFp.deliveryAddressesAll(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Duplicate the client
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateClient(clientId, options) {
            return localVarFp.duplicateClient(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Client Organization
         * @param {string} clientId Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganization(clientId, options) {
            return localVarFp.getClientOrganization(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Client Organization by Sage Numero Client
         * @param {string} numeroClient Numero Client id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientOrganizationByNumeroClient(numeroClient, options) {
            return localVarFp.getClientOrganizationByNumeroClient(numeroClient, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddress(clientId, deliveryAddressId, options) {
            return localVarFp.getDeliveryAddress(clientId, deliveryAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Client Organization
         * @param {string} clientId Client id
         * @param {ClientOrganizationFormUpdate} [clientOrganizationFormUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientOrganization(clientId, clientOrganizationFormUpdate, options) {
            return localVarFp.updateClientOrganization(clientId, clientOrganizationFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Delivery Address
         * @param {string} clientId Client id
         * @param {string} deliveryAddressId Delivery Address id
         * @param {DeliveryAddressForm} [deliveryAddressForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options) {
            return localVarFp.updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TeamsRestApi - object-oriented interface
 * @export
 * @class TeamsRestApi
 * @extends {BaseAPI}
 */
class TeamsRestApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add client group
     * @param {ClientGroupForm} clientGroupForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    addClientGroup(clientGroupForm, options) {
        return exports.TeamsRestApiFp(this.configuration).addClientGroup(clientGroupForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add Client Organization
     * @param {ClientOrganizationForm} clientOrganizationForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    addClientOrganization(clientOrganizationForm, options) {
        return exports.TeamsRestApiFp(this.configuration).addClientOrganization(clientOrganizationForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add Delivery Address
     * @param {string} clientId Client id
     * @param {DeliveryAddressForm} deliveryAddressForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    addDeliveryAddress(clientId, deliveryAddressForm, options) {
        return exports.TeamsRestApiFp(this.configuration).addDeliveryAddress(clientId, deliveryAddressForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of client teams
     * @param {'nom' | 'dateCreation'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} [nom]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    allClientList(sortField, sortOrder, nom, sageBase, options) {
        return exports.TeamsRestApiFp(this.configuration).allClientList(sortField, sortOrder, nom, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of client groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    allGroupList(options) {
        return exports.TeamsRestApiFp(this.configuration).allGroupList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary All Sage users
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    allSageUsers(sageBase, options) {
        return exports.TeamsRestApiFp(this.configuration).allSageUsers(sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Paginated client teams
     * @param {number} page
     * @param {number} size
     * @param {'nom' | 'dateCreation'} sortField
     * @param {'DESC' | 'ASC'} sortOrder
     * @param {string} [search]
     * @param {'SERVICE' | 'HARDWARE' | 'AFFID'} [sageBase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options) {
        return exports.TeamsRestApiFp(this.configuration).clientTeamsPaginated(page, size, sortField, sortOrder, search, sageBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Stellair account
     * @param {string} clientId Client id
     * @param {StellairAccountForm} stellairAccountForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    createStellairAccount(clientId, stellairAccountForm, options) {
        return exports.TeamsRestApiFp(this.configuration).createStellairAccount(clientId, stellairAccountForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary All delivery addresses
     * @param {string} clientId Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    deliveryAddressesAll(clientId, options) {
        return exports.TeamsRestApiFp(this.configuration).deliveryAddressesAll(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Duplicate the client
     * @param {string} clientId Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    duplicateClient(clientId, options) {
        return exports.TeamsRestApiFp(this.configuration).duplicateClient(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Client Organization
     * @param {string} clientId Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    getClientOrganization(clientId, options) {
        return exports.TeamsRestApiFp(this.configuration).getClientOrganization(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Client Organization by Sage Numero Client
     * @param {string} numeroClient Numero Client id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    getClientOrganizationByNumeroClient(numeroClient, options) {
        return exports.TeamsRestApiFp(this.configuration).getClientOrganizationByNumeroClient(numeroClient, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Delivery Address
     * @param {string} clientId Client id
     * @param {string} deliveryAddressId Delivery Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    getDeliveryAddress(clientId, deliveryAddressId, options) {
        return exports.TeamsRestApiFp(this.configuration).getDeliveryAddress(clientId, deliveryAddressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Client Organization
     * @param {string} clientId Client id
     * @param {ClientOrganizationFormUpdate} [clientOrganizationFormUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    updateClientOrganization(clientId, clientOrganizationFormUpdate, options) {
        return exports.TeamsRestApiFp(this.configuration).updateClientOrganization(clientId, clientOrganizationFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Delivery Address
     * @param {string} clientId Client id
     * @param {string} deliveryAddressId Delivery Address id
     * @param {DeliveryAddressForm} [deliveryAddressForm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsRestApi
     */
    updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options) {
        return exports.TeamsRestApiFp(this.configuration).updateDeliveryAddress(clientId, deliveryAddressId, deliveryAddressForm, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TeamsRestApi = TeamsRestApi;
